//See example at https://github.com/patternfly/patternfly-react/blob/main/packages/react-table/src/demos/sampleData.tsx
//for applying randomisation to data

import React from 'react';
import { DesktopIcon } from '@patternfly/react-icons/dist/esm/icons/desktop-icon';
import { UserIcon } from '@patternfly/react-icons/dist/esm/icons/user-icon';
import { NetworkIcon } from '@patternfly/react-icons/dist/esm/icons/network-icon';
import { PlusIcon } from '@patternfly/react-icons/dist/esm/icons/plus-icon';

export const highPriorityThresh = 8;    //All priority values greater than this are 'High'
export const lowPriorityThresh = 6;     //All priority values less than this are 'Low'
//All other priority values are 'Medium'

export interface summaryFindingsSampleDataRow {
  Type: string;
  NumIdentified: number;
  NumFindings: string;
}

export interface environmentFindingsSampleDataRow {
  Source: string;
  Priority: number;
  FindingName: string;
  Description: string;
  Remediation: string;
  Resource: string;
  MoreInfo: string;
}

export interface assetFindingsSampleDataRow {
  Source: string;
  Resource: string;
  Priority: number;
  FindingName: string;
  Category: string;
  Description: string;
  SuggestedRemediation: string;
}

export interface accountFindingsSampleDataRow {
   Source: string;
   Resource: string;
   Priority: number;
   FindingName: string;
   Description: string;
   SuggestedRemediation: string;
 }

export interface accountsSampleDataRow {
  Source: string;
  Firstname: string;
  Lastname: string;
  Email: string;
  LastActivity: string;
  MFAStatus: string;
  PrivilegedRoles: string;
}

export interface assetsSampleDataRow {
   Source: string;
   Hostname: string;
   IPAddress: string;
   OSType: string;
   OSName: string;
   OSVersion: string;
   LastSeen: string;
   DefenderCoverage: string;
   IntuneCoverage: string;
 }

export const summaryFindingsColumns = [
  '',
  'Number Identified',
  'Number of Findings'
];

export const environmentFindingsColumns = [
  'Source',
  'Priority',
  'Finding Name',
  'Resource',
  'Description',
  'Remediation',
  'More Info'
];

export const assetFindingsColumns = [
    'Source',
    'Priority',
    'Finding Name',
    'Resource',
    'Category',
    'Description',
    'Suggested Remediation'
];

export const accountFindingsColumns = [
    'Source',
    'Priority',
    'Finding Name',
    'Resource',
    'Description',
    'Suggested Remediation'
];

export const accountsColumns = [
  'Source',
  'Firstname',
  'Lastname',
  'Email',
  'Last Activity',
  'MFA Status',
  'Privileged Roles'
];

export const assetsColumns = [
  'Source',
  'Hostname',
  'IP Address',
  'OS Type',
  'OS Name',
  'OS Version',
  'Last Seen',
  'Defender Coverage',
  'Intune Coverage'
];

export const summaryFindingsRows: summaryFindingsSampleDataRow[] = [
  {
    "Type": <><NetworkIcon /> <a href='findings/environmentFindings'>Environments</a></>,
    "NumIdentified": "1",
    "NumFindings": "95"
  },
  {
    "Type": <><DesktopIcon /> <a href='findings/assetFindings'>Assets</a></>,
    "NumIdentified": "100",
    "NumFindings": "132"
  },
  {
    "Type": <><UserIcon /> <a href='findings/accountFindings'>Accounts</a></>,
    "NumIdentified": "400",
    "NumFindings": "7"
  },
  {
    "Type": <><PlusIcon /> <a href='findings/summary'>Other</a></>,
    "NumIdentified": "1",
    "NumFindings": "8"
  }
];

export const environmentFindingsRows: environmentFindingsSampleDataRow[] = [
  {
    "Number": "1",
    "Source": "CyberCheck",
    "Priority": "10",
    "FindingName": "CyberCheck_Sharepoint Legacy Auth (CIS)",
    "Description": "Legacy authentication is enabled for sharepoint.",
    "Remediation": "1. Navigate to SharePoint admin center https://admin.microsoft.com/sharepoint.\n2. Click to expand Policies select Access control.\n3. Select Apps that don't use modern authentication and ensure that it is set to Block access.",
    "Resource": "Sharepoint Link",
    "MoreInfo": "https://learn.microsoft.com/en-us/sharepoint/external-sharing-overview#how-the-external-sharing-settings-work"
  },
  {
    "Number": "2",
    "Source": "CyberCheck",
    "Priority": "5",
    "FindingName": "CyberCheck_OneDrive Sync To Untrusted (CIS)",
    "Description": "Ensure that onedrive is configured to only enable synchronisation to ad-joined machines.",
    "Remediation": "1. Navigate to SharePoint admin center https://admin.microsoft.com/sharepoint\n2. Click Settings followed by OneDrive - Sync\n3. Verify that Allow syncing only on computers joined to specific domains is checked.",
    "Resource": "Onedrive Link",
    "MoreInfo": "https://learn.microsoft.com/en-us/sharepoint/allow-syncing-only-on-specific-domains"
  },
  {
    "Number": "3",
    "Source": "MS365",
    "Priority": "10",
    "FindingName": "AdminMFAV2",
    "Description": "Ensure multifactor authentication is enabled for all users in administrative roles",
    "Remediation": "We provide step-by-step guidance to select and enable the right MFA method for your organization in the Microsoft 365 admin center. Go to the Microsoft 365 MFA If you would like to perform the implementation yourself, first check what Microsoft Entra ID li",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2095010"
  },
  {
    "Number": "4",
    "Source": "MS365",
    "Priority": "8",
    "FindingName": "mdo_enablemailboxintelligence",
    "Description": "Ensure that mailbox intelligence is enabled",
    "Remediation": "Ensure that all users have an assigned anti-phishing policy with the &lsquo;Enable mailbox intelligence&rsquo; option enabled, by either updating your existing policies or creating new ones.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antiphishing"
  },
  {
    "Number": "5",
    "Source": "MS365",
    "Priority": "8",
    "FindingName": "mdo_enabledomainstoprotect",
    "Description": "Enable impersonated domain protection",
    "Remediation": "Ensure that all users have an assigned anti-phishing policy with &lsquo;Enable domains to protect&rsquo;, &lsquo;Include domains I own&rsquo; and &lsquo;Include custom domains&rsquo; options enabled, by either updating your existing policies or creating ne",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antiphishing"
  },
  {
    "Number": "6",
    "Source": "MS365",
    "Priority": "8",
    "FindingName": "BlockLegacyAuthentication",
    "Description": "Enable Conditional Access policies to block legacy authentication",
    "Remediation": "We provide step-by-step guidance to select and enable the right method to block legacy authentication for your organization in the Microsoft 365 admin center (part of the MFA wizard). Go to the Microsoft 365 MFA wizardIf you would like to perform the imple",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2095010"
  },
  {
    "Number": "7",
    "Source": "MS365",
    "Priority": "8",
    "FindingName": "AATP_GroupPolicyPasswordInPreferences",
    "Description": "Reversible passwords found in GPOs",
    "Remediation": "In order to remove the preferences that contain passwords data, use Group Policy Management Console (GPMC) on a domain controller or from a client that has Remote Server Administration Tools (RSAT) installed. You can remove any preference following these s",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdi/ispm-gpopwdgpp"
  },
  {
    "Number": "8",
    "Source": "MS365",
    "Priority": "8",
    "FindingName": "AATP_EntraConnectAccountUnnecessaryReplicationPermission",
    "Description": "Remove unnecessary replication permissions for Entra Connect AD DS Connector Account",
    "Remediation": "1. Review the list of exposed entities to discover which of your AD DS Connector accounts have replication permissions. 2. Take appropriate action on those accounts by removing their 'Replication Directory Changes' and 'Replication Directory Changes All' p",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/IspmEntraConnectReplicationPermissions"
  },
  {
    "Number": "9",
    "Source": "MS365",
    "Priority": "8",
    "FindingName": "AATP_DnsAdminsGroupWithUnsafePermissions",
    "Description": "Unsafe permissions on the DnsAdmins group",
    "Remediation": "1. Review the list of exposed entities to identify non-privileged accounts with risky permissions. 2. Take appropriate action on those accounts by removing the accounts from the DnsAdmins group. If some accounts require these permissions, grant them only t",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/IspmUnsafePermissionsDnsAdminsGroup"
  },
  {
    "Number": "10",
    "Source": "MS365",
    "Priority": "7",
    "FindingName": "aad_phishing_MFA_strength",
    "Description": "Ensure 'Phishing-resistant MFA strength' is required for Administrators",
    "Remediation": "To create a phishing-resistant MFA CA policy for users in administrative roles:  Navigate to the Microsoft Entra ID admin center https://entra.microsoft.com Click to expand Microsoft Entra ID &gt;  select Enterprise Applications Under , select Conditional ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/azure/active-directory/identity-protection/howto-identity-protection-configure-mfa-policy"
  },
  {
    "Number": "11",
    "Source": "MS365",
    "Priority": "7",
    "FindingName": "AATP_GroupPolicyAssignsUnprivilegedIdentitiesToElevatedLocalGroups",
    "Description": "GPO assigns unprivileged identities to local groups with elevated privileges",
    "Remediation": "Carefully review each assigned group membership, identify any dangerous group membership granted, and modify the GPO to remove any unnecessary or excessive user rights.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdi/ispm-gpolocalgroups"
  },
  {
    "Number": "12",
    "Source": "MS365",
    "Priority": "7",
    "FindingName": "AppG_unusual_activity_with_priority_account",
    "Description": "Regulate apps with priority account consent",
    "Remediation": "In app governance, open the predefined \"Unusual activity from an app with priority account consent\" policy and activate it.            While you have the policy open, you can add an action to take on unused apps and add exceptions.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/cloudapps/app-governance?viewid=policies&objid=true&filter=%7B%22source%22:%5B%22Predefined%22%5D%7D"
  },
  {
    "Number": "13",
    "Source": "MS365",
    "Priority": "7",
    "FindingName": "AppG_regulate_access_to_sensitive_data",
    "Description": "Regulate cloud app access to sensitive data",
    "Remediation": "In app governance, open the predefined policy \"Access to sensitive data\" and activate it.            You can edit the predefined policy to specify an action and add exceptions.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/cloudapps/app-governance?viewid=policies&objid=true&filter=%7B%22source%22:%5B%22Predefined%22%5D%7D"
  },
  {
    "Number": "14",
    "Source": "MS365",
    "Priority": "6",
    "FindingName": "aad_password_protection",
    "Description": "Ensure password protection is enabled for on-prem Active Directory",
    "Remediation": "To setup Microsoft Entra ID Password Protection, use the following steps:&nbsp;  Download and install the Microsoft Entra ID Password Proxies and DC Agents from the following location: https://www.microsoft.com/download/details.aspx?id=57071 After the inst",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/azure/active-directory/authentication/howto-password-ban-bad-on-premises-operations"
  },
  {
    "Number": "15",
    "Source": "MS365",
    "Priority": "6",
    "FindingName": "forms_phishing_protection",
    "Description": "Ensure internal phishing protection for Forms is enabled",
    "Remediation": "To enable internal phishing protection for Forms:  Navigate to Microsoft 365 admin center https://admin.microsoft.com 2. Click to expand  then select Org settings3. Under Services select Microsoft Forms4. Click the checkbox labeled Add internal phishing pr",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-US/microsoft-forms/review-unblock-forms-users-detected-blocked-potential-phishing"
  },
  {
    "Number": "16",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "mdo_blockmailforward",
    "Description": "Ensure all forms of mail forwarding are blocked and/or disabled",
    "Remediation": ": In this control, remediation is carried out in two stages - Step 1 is manual and will not be monitored automatically by secure score, whereas Step 2 is monitored automatically: STEP 1: Transport rules To alter the mail transport rules so they do not forw",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/exchange/policy-and-compliance/mail-flow-rules/mail-flow-rule-procedures?view=exchserver-2019"
  },
  {
    "Number": "17",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "exo_individualsharing",
    "Description": "Ensure 'External sharing' of calendars is not available",
    "Remediation": "In the Microsoft 365 Exchange admin center, go to&nbsp;Organization &gt; Sharing.Under Individual Sharing, make sure all policies are unticked.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://admin.exchange.microsoft.com/#/sharing"
  },
  {
    "Number": "18",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSMisconfiguredRpcEnrollmentSigning",
    "Description": "Enforce encryption for RPC certificate enrollment interface (ESC8)",
    "Remediation": "To require packet encryption for RPC enrollment, execute the following command and then restart the certsvc service: certutil -setreg CA\\InterfaceFlags +IF_ENFORCEENCRYPTICERTREQUESTnet stop certsvc & net start certsvc",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc8"
  },
  {
    "Number": "19",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "mdo_commonattachmentsfilter",
    "Description": "Ensure the Common Attachment Types Filter is enabled",
    "Remediation": "Update your existing policies or create new ones to ensure that all users have an assigned anti-malware policy with the &lsquo;Enable common attachments filter&rsquo; option turned on .",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antimalwarev2"
  },
  {
    "Number": "20",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "mdo_atpprotection",
    "Description": "Turn on Microsoft Defender for Office 365 in SharePoint, OneDrive, and Microsoft Teams",
    "Remediation": "Ensure that the following global tenant setting for &lsquo;Safe Attachments&rsquo; is Turn on the Defender for Office 365 for SharePoint, OneDrive, and Microsoft TeamsFor detailed implementation instructions, see Turn on Safe Attachments for SharePoint, On",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/safeattachmentv2"
  },
  {
    "Number": "21",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "dlp_datalossprevention",
    "Description": "Ensure DLP policies are enabled",
    "Remediation": "Ensure that at least one Microsoft 365 DLP policy exists in the Microsoft 365 Compliance portal        Learn more                        Learn about data loss prevention | Microsoft Docs                    Create, test, and tune a DLP policy - Microsoft 36",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://compliance.microsoft.com/datalossprevention"
  },
  {
    "Number": "22",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_GroupPolicyAbnormalModificationAssignment",
    "Description": "GPO can be modified by unprivileged accounts",
    "Remediation": "Carefully review each assigned permission, identify any dangerous permission granted, and modify them to remove any unnecessary or excessive user rights. For more information, please refer to the security advisory in the \"Learn More\" section.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdi/ispm-gpoexposed"
  },
  {
    "Number": "23",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_KerberosDelegations",
    "Description": "Modify unsecure Kerberos delegations to prevent impersonation",
    "Remediation": "1. Review this security control list of exposed entities to discover which of your non-domain controller entities are configured for unsecure Kerberos delegation.  2. Take appropriate action on those at-risk users, such as removing their unconstrained attr",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123722"
  },
  {
    "Number": "24",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_WeakCipher",
    "Description": "Stop weak cipher usage",
    "Remediation": "1. Review this security control list of exposed entities.  2. Research why the identified clients and servers are using weak ciphers.  3. Remediate the issues and disable use of RC4 and/or other weak ciphers (such as DES/3DES).  To achieve a full score, yo",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123721"
  },
  {
    "Number": "25",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_SIDHistory",
    "Description": "Remove unsecure SID history attributes from entities",
    "Remediation": "1. Review this security control list of exposed entities that has unsecure SID history attributes. 2. Take appropriate action on those entities by removing their unsecure settings.  To achieve a full score, you must remediate all exposed entities.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123183"
  },
  {
    "Number": "26",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ClearText",
    "Description": "Stop clear text credentials exposure",
    "Remediation": "1. Review this security control list of exposed entities.  2. Research why those entities are using LDAP in clear text.  3. Remediate the issues and stop the exposure.  4. After confirming remediation, we recommend you configure the requirement of domain c",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123179"
  },
  {
    "Number": "27",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_DormantAccounts",
    "Description": "Remove dormant accounts from sensitive groups",
    "Remediation": "1. Review this security control list of exposed entities to discover which of your sensitive accounts are dormant.. 2. Take appropriate action on those entities by removing their privileged access rights or by deleting the account.  To achieve a full score",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123908"
  },
  {
    "Number": "28",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_PwdLAPS",
    "Description": "Protect and manage local admin passwords with Microsoft LAPS",
    "Remediation": "1. Review this security control list of domains and devices not configured for Microsoft LAPS.  2. Deploy Microsoft LAPS to actively manage the local administrator password of your devices. This is done through Active Directory along with Group Policy clie",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123725"
  },
  {
    "Number": "29",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_AdminSDHolder",
    "Description": "Remove access rights on suspicious accounts with the Admin SDHolder permission",
    "Remediation": "1. Review the list of exposed entities to discover which of your non-sensitive accounts have the Admin SDHolder permission. 2. Take appropriate action on those entities by removing their privileged access rights. To achieve the full score, remediate all ex",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/ispmsdholder"
  },
  {
    "Number": "30",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_UnsecureAccount",
    "Description": "Resolve unsecure account attributes",
    "Remediation": "1. Review this security control list of exposed entities that has unsecure account attributes. 2. Take appropriate action on those entities by removing their unsecure settings.  To achieve a full score, you must remediate all exposed entities.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123364"
  },
  {
    "Number": "31",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_PathRisk",
    "Description": "Reduce lateral movement path risk to sensitive entities",
    "Remediation": "Review this security control list of exposed entities displaying sensitive entities with lateral movement paths risk with recommended actions on how to reduce the number of non-sensitive accounts for each path.  To achieve a full score, you must remediate ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123182"
  },
  {
    "Number": "32",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSMisconfiguredCertificateTemplateEnrollmentAgent",
    "Description": "Edit misconfigured enrollment agent certificate template (ESC3)",
    "Remediation": "Identify the vulnerable certificate template. Perform at least one of the following possible remediations: 1.Remove enrollment agent EKU. 2.Remove overly permissive enrollment permissions, which allows any user to enroll certificate based on that certifica",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc3"
  },
  {
    "Number": "33",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_PrintSpooler",
    "Description": "Disable Print spooler service on domain controllers",
    "Remediation": "1. Review this security control list of exposed entities to discover which of your domain controllers has the Print spooler service enabled. 2. Take appropriate action on the at-risk domain controllers and actively remove the Print spooler service either m",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2123723"
  },
  {
    "Number": "34",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_NonAdminDCSyncAccounts",
    "Description": "Remove non-admin accounts with DCSync permissions",
    "Remediation": "1. Review this list of exposed entities to discover which of your accounts have DCSync permissions and are also non-domain admins. 2. Take appropriate action on those entities by removing their privileged access rights. To achieve the full score, remediate",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/ispmdcsync"
  },
  {
    "Number": "35",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_AzureSsoAccountOldPasswords",
    "Description": "Change password for Entra seamless SSO account",
    "Remediation": "For each account, follow these steps:  1.Review this list of exposed entities to discover which of your accounts have an old password. 2.Take appropriate action on those entities by following the steps described here: https://aka.ms/RollOverAzureadssoAccou",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/IspmAzureSsoPassword"
  },
  {
    "Number": "36",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_PrivilegedAccountsWithDelegationAllowed",
    "Description": "Ensure privileged accounts are not delegated",
    "Remediation": "1. Review the list of exposed entities to discover which of your privileged user accounts don’t have the configuration flag \"this account is sensitive and cannot be delegated\".  2. Take appropriate action on those accounts by setting the account's control ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2282834"
  },
  {
    "Number": "37",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_AccountsWithNonDefaultPrimaryGroup",
    "Description": "Accounts with non-default Primary Group ID",
    "Remediation": "1, Review the list of exposed entities to discover which of your accounts have a suspicious primaryGroupId.   2. Take appropriate action on those accounts by resetting their attribute to their default values or adding the member to the relevant group:  - u",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2282057"
  },
  {
    "Number": "38",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_BuiltinGuestAccountIsEnabled",
    "Description": "Built-in Active Directory Guest account is enabled",
    "Remediation": "1. Review the list of exposed entities to discover if there is a Guest account which is enabled.  2. Take appropriate action on those accounts by disabling the account.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2283225"
  },
  {
    "Number": "39",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSCertificateTemplateArbitraryAppPolicies",
    "Description": "Prevent Certificate Enrollment with arbitrary Application Policies (ESC15)",
    "Remediation": "1. Identify the vulnerable certificate templates:-Remove enrollment permission for unprivileged users.-Disable the “Supply in the request” option.2. Identify the AD CS servers which are vulnerable to CVE-2024-49019 and apply the relevant patch.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2296922"
  },
  {
    "Number": "40",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSMisconfiguredCertificateTemplateOwner",
    "Description": "Edit misconfigured certificate templates owner (ESC4)",
    "Remediation": "Edit misconfigured certificate templates owner (ESC4)",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc4"
  },
  {
    "Number": "41",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSCertificateTemplateEnrolementSuppliesSubject",
    "Description": "Prevent users to request a certificate valid for arbitrary users based on the certificate template (ESC1)",
    "Remediation": "Identify the vulnerable certificate template. Perform at least one of the following possible remediations: 1. Disable the “Supply in the request” configuration. 2. Remove EKU’s enabling user authentication (e.g Client Authentication). 3.Remove overly permi",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc1"
  },
  {
    "Number": "42",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSInsecureCertificateEnrollmentIisEndpoints",
    "Description": "Edit insecure certificate enrollment IIS endpoints (ESC8)",
    "Remediation": "For each endpoint, follow these steps: 1. Determine whether the endpoint is necessary and in regular use. If it is not used, it is advisable to disable it. 2. Deactivate NTLM and Negotiate authentication providers for the IIS endpoint. 3. If NTLM cannot be",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc8IIS"
  },
  {
    "Number": "43",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSMisconfiguredCertificateAuthorityAcl",
    "Description": "Edit misconfigured Certificate Authority ACL (ESC7)",
    "Remediation": "Identify the misconfigured ACL entry (for example - “Manage CA” permission granted to the “authenticated users” built-in group) and remove any unnecessary permissions granting built-in groups “Mange CA” or/and “Manage certificates” permissions.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc7"
  },
  {
    "Number": "44",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSMisconfiguredCertificateTemplateAcl",
    "Description": "Edit misconfigured certificate templates ACL (ESC4)",
    "Remediation": "Identify the vulnerable certificate template, and remove overly permissive modifications permissions (e.g. WriteProperty), which allows any user to change the settings of that certificate template.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc4ACL"
  },
  {
    "Number": "45",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSSanSpecifiedByUserEnabled",
    "Description": "Edit vulnerable Certificate Authority setting (ESC6)",
    "Remediation": "To disable “user specifying SAN” setting, execute the following command and then restart the certsvc service: certutil -setreg policy\\EditFlags -EDITF_ATTRIBUTESUBJECTALTNAME2 net stop certsvc & net start certsvc",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc6"
  },
  {
    "Number": "46",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_BuiltinAdministratorAccountWithOldPassword",
    "Description": "Change password of built-in domain Administrator account",
    "Remediation": "1. Review the list of exposed entities to discover which of your built-in domain Administrator accounts have an old password. 2. Take appropriate action on those accounts by resetting their password.To achieve the full score, remediate all exposed entities",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2283818"
  },
  {
    "Number": "47",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_DomainControllersWithOldPassword",
    "Description": "Change Domain Controller computer account old password",
    "Remediation": "1. Verify Registry Values:  HKLM\\System\\CurrentControlSet\\Services\\Netlogon\\Parameters\\DisablePasswordChange is set to 0 or is nonexistent.  HKLM\\System\\CurrentControlSet\\Services\\Netlogon\\Parameters\\MaximumPasswordAge is set to 30.  2. Reset Incorrect Val",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/IspmDcWithOldPassword"
  },
  {
    "Number": "48",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_BuiltinKrbtgtAccountWithOldPassword",
    "Description": "Change password for krbtgt account",
    "Remediation": "1. Review the list of exposed entities to discover which of your krbtgt accounts have an old password.2. Take appropriate action on those accounts by resetting their password twice to invalidate the Golden Ticket attack. To achieve the full score, remediat",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2283220"
  },
  {
    "Number": "49",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_UnsecureDomain",
    "Description": "Resolve unsecure domain configurations",
    "Remediation": "1. Review this security control list of exposed domains that have unsecure configurations. 2. Take appropriate action on those domains by remediating their unsecure settings. To achieve a full score, you must remediate all exposed entities.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2196300"
  },
  {
    "Number": "50",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_DomainControllerLocalUsers",
    "Description": "Remove local admins on identity assets",
    "Remediation": "1. Review this list of exposed entities to discover which of your accounts have local admin rights on your identity assets. 2. Take appropriate action on those entities by removing their privileged access rights. To achieve the full score, remediate all ex",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/ispmt0assets"
  },
  {
    "Number": "51",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_DefenderForIdentityIsNotInstalled",
    "Description": "Start your Defender for Identity deployment, installing Sensors on Domain Controllers and other eligible servers.",
    "Remediation": "Go to the sensor page in Settings, you can view the already installed sensors in your environment and download the install package to deploy them on your remaining domain controllers.  You will be scored as a precentage of your deployment progress.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/settings/identities?tabid=sensor"
  },
  {
    "Number": "52",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "AATP_ADCSMisconfiguredCertificateTemplateEku",
    "Description": "Edit overly permissive Certificate Template with privileged EKU (Any purpose EKU or No EKU) (ESC2)",
    "Remediation": "Identify the vulnerable certificate template. Perform at least one of the following possible remediations: 1.Remove EKU’s enabling arbitrary usage (e.g. Any purpose). 2.Remove overly permissive enrollment permissions, which allows any user to enroll certif",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/mdiesc2"
  },
  {
    "Number": "53",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "aad_admin_consent_workflow",
    "Description": "Ensure the admin consent workflow is enabled",
    "Remediation": " In the Microsoft 365 Admin Center, Select Admin Centers, and Microsoft Entra ID Select Enterprise applications from the Azure Navigation pane. Under Security select Consent and permissions Under  select Admin consent settings and set Users can request adm",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aad.portal.azure.com/#view/Microsoft_AAD_IAM/ConsentPoliciesMenuBlade/~/UserSettings"
  },
  {
    "Number": "54",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "aad_custom_banned_passwords",
    "Description": "Ensure custom banned passwords lists are used",
    "Remediation": "Create a custom banned password list:  Navigate to Microsoft Entra ID admin center https://entra.microsoft.com/ Click to expand Microsoft Entra ID &gt; Protect &amp; Secure &gt; Authentication methods Select Password protection Set Enforce custom list to  ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/azure/active-directory/authentication/tutorial-configure-custom-password-protection"
  },
  {
    "Number": "55",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "aad_sign_in_freq_session_timeout",
    "Description": "Ensure Sign-in frequency is enabled and browser sessions are not persistent for Administrative users",
    "Remediation": "To configure Sign-in frequency and browser sessions persistence for Administrative users:  Navigate to Microsoft Entra admin center https://entra.microsoft.com/Click to  &gt; Conditional Access Click New policy Click Users and groups Under  select Select u",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aad.portal.azure.com/#view/Microsoft_AAD_ConditionalAccess/PolicyBlade"
  },
  {
    "Number": "56",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "aad_third_party_apps",
    "Description": "Ensure third party integrated applications are not allowed",
    "Remediation": "In the Microsoft 365 Admin Center Select Admin Centers and Microsoft Entra IDSelect Users from the Azure navigation paneSelect Users settingsSet App registrations is set to Click ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/microsoft-365/enterprise/integrated-apps-and-azure-ads?view=o365-worldwide"
  },
  {
    "Number": "57",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "exo_SPF_records_for_all_domains",
    "Description": "Ensure that SPF records are published for all Exchange Domains",
    "Remediation": "follow the instructions on&nbsp;Set up SPF to help prevent spoofing - Office 365 | Microsoft Learn",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/microsoft-365/security/office-365-security/set-up-spf-in-office-365-to-help-prevent-spoofing?view=o365-worldwide"
  },
  {
    "Number": "58",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "exo_storageproviderrestricted",
    "Description": "Ensure additional storage providers are restricted in Outlook on the web",
    "Remediation": "Restrict additional storage providers are restricted using PowerShell:  Connect to Exchange Online using  Run the following PowerShell command:Set-OwaMailboxPolicy -Identity OwaMailboxPolicy-Default -AdditionalStorageProvidersAvailable $false Run the follo",
    "Resource": "MS365 Tenant",
    "MoreInfo": ""
  },
  {
    "Number": "59",
    "Source": "MS365",
    "Priority": "5",
    "FindingName": "mcas_mda_enabled",
    "Description": "Ensure Microsoft Defender for Cloud Apps is enabled and configured",
    "Remediation": "Enable Defender for Cloud Apps by the following instructions: https://learn.microsoft.com/en-us/defender-cloud-apps/get-started",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/defender-cloud-apps/get-started"
  },
  {
    "Number": "60",
    "Source": "MS365",
    "Priority": "4",
    "FindingName": "AATP_Sensor",
    "Description": "Install Defender for Identity Sensor on all Domain Controllers",
    "Remediation": "Go to the sensor page  in Settings, you can view the already installed sensors in your environment and download the install package to deploy them on your remaining domain controllers.  You will be scored as a precentage of your deployment progress.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2117505"
  },
  {
    "Number": "61",
    "Source": "MS365",
    "Priority": "4",
    "FindingName": "McasOAuthAppNotification",
    "Description": "Create an OAuth app policy to notify you about new OAuth applications",
    "Remediation": " In the Defender for Cloud Apps portal, go to the OAuth app policy page. Select the policy severity and application (if relevant).  Select filters according to your business requirements. (Optional) Configure alerts settings such as email and text message ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/cloudapps/policy/app-permission/create"
  },
  {
    "Number": "62",
    "Source": "MS365",
    "Priority": "4",
    "FindingName": "IntegratedApps",
    "Description": "Ensure user consent to apps accessing company data on their behalf is not allowed",
    "Remediation": "Go to Microsoft Entra ID &gt; Enterprise applications &gt; Consent and permissions. Go to Consent and permissionsSelect &ldquo;Allow user consent for apps from verified publishers, for selected permissions (Recommended)&ldquo; to follow Microsoft&rsquo;s b",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://go.microsoft.com/fwlink/?linkid=2119526"
  },
  {
    "Number": "63",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "aad_limited_administrative_roles",
    "Description": "Ensure 'Microsoft Azure Management' is limited to administrative roles",
    "Remediation": "To enable Microsoft Azure Management restrictions:  Navigate to the Microsoft Entra ID admin center https://entra.microsoft.com Click expand  &gt; Conditional Access select  Click New Policy and then name the policy. Select  &gt;  &gt; All Users Select  &g",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/azure/active-directory/conditional-access/concept-conditional-access-cloud-apps"
  },
  {
    "Number": "64",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "exo_transportrulesallowlistdomains",
    "Description": "Ensure Spam confidence level (SCL) is configured in mail transport rules with specific domains",
    "Remediation": "To modify SCL in mail transport rules so they do not allow any specific domains:  Navigate to&nbsp;Exchange admin centerhttps://admin.exchange.microsoft.com Click to expand&nbsp;Mail Flow&nbsp;and then select&nbsp; For each rule that allows specific domain",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://admin.exchange.microsoft.com/#/transportrules"
  },
  {
    "Number": "65",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "mdo_bulkspamaction",
    "Description": "Set action to take on bulk spam detection",
    "Remediation": "Ensure that all users have an assigned inbound anti-spam policy with the &lsquo;Bulk complaint level (BCL) met or exceeded&rsquo; option set to &ldquo;Move message to Junk Email folder&rdquo;, by either updating your existing policies or creating new ones.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antispam"
  },
  {
    "Number": "66",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "McasCloudAppNotification",
    "Description": "Create an app discovery policy to identify new and trending cloud apps in your org",
    "Remediation": " In the Defender for Cloud Apps portal, go to the App discovery policy page.   Select the policy severity. Select filters according to your business requirements, then select the reports this policy will apply to. (Optional) Configure alerts settings such ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/cloudapps/policy/discovery/create"
  },
  {
    "Number": "67",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "AATP_EntraConnectAccountsOldPasswords",
    "Description": "Rotate password for Entra Connect AD DS Connector account",
    "Remediation": "1. Review the list of exposed entities to discover which of your AD DS Connector accounts have a password more than 90 days old. 2. Take appropriate action on those accounts by following the steps described here: https://aka.ms/EntraIdPasswordChangeSyncSer",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://aka.ms/IspmRotatePasswordEntraConnect"
  },
  {
    "Number": "68",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_minimum_password_length",
    "Description": "Ensure that mobile devices require a minimum password length to prevent brute force attacks",
    "Remediation": "To ensure that mobile devices require a complex password, use the Microsoft Intune admin center  Select , then under select Configuration profiles&nbsp; If there are no policies, select Create Policy.  Set a for the policy, choose the appropriate and selec",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "69",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "aad_admin_accounts_separate_unassigned_cloud_only",
    "Description": "Ensure Administrative accounts are separate and cloud-only",
    "Remediation": "1. Navigate to Microsoft 365 admin center 2. Click to expand Users select Active users.3. Sort by the Licenses column.4. For each user account in an administrative role verify the following: The account is Cloud only (not synced) The account is assigned a ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/microsoft-365/admin/add-users/add-users?view=o365-worldwide"
  },
  {
    "Number": "70",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "aad_linkedin_connection_disables",
    "Description": "Ensure 'LinkedIn account connections' is disabled",
    "Remediation": "To disable LinkedIn account connections:  Navigate to Microsoft Entra ID admin center https://entra.microsoft.com/ Click to expand Microsoft Entra ID &gt; Users select User settings Under LinkedIn account connections select  Click Save at the top of the pa",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/azure/active-directory/enterprise-users/linkedin-integration"
  },
  {
    "Number": "71",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "admincenter_owned_apps_and_services",
    "Description": "Ensure 'User owned apps and services' is restricted",
    "Remediation": "To prohibit users installing Office Store add-ins and starting 365 trials:  Navigate to Microsoft 365 admin center https://admin.microsoft.com Click to expand  Select Org settings3. Under  select User owned apps and services4. Uncheck Let users access the ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/microsoft-365/admin/manage/manage-addins-in-the-admin-center?view=o365-worldwide"
  },
  {
    "Number": "72",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "mdo_antiphishingpolicies",
    "Description": "Ensure that an anti-phishing policy has been created",
    "Remediation": ": Audit and Remediation guidance may focus on the Default policy however, if a Custom Policy exists in the organization's tenant then ensure the setting is set as outlined in the highest priority policy listed. To set the anti-phishing policy -  Navigate t",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/microsoft-365/security/office-365-security/anti-phishing-policies-about?view=o365-worldwide"
  },
  {
    "Number": "73",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "aad_managed_approved_public_groups_only",
    "Description": "Ensure that only organizationally managed/approved public groups exist",
    "Remediation": "In the Microsoft 365 Administration&nbsp;portal, go to:Teams &amp; groups -&gt;&nbsp;Active teams &amp; groupsFor each group, under make sure  is set to &apos;",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/microsoft-365/admin/create-groups/compare-groups?view=o365-worldwide#microsoft-365-groups"
  },
  {
    "Number": "74",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "exo_mailboxaudit",
    "Description": "Ensure mailbox auditing for all users is Enabled",
    "Remediation": "To enable mailbox auditing for all users:  Connect to Exchange Online using  Run the following PowerShell command:Set-OrganizationConfig -AuditDisabled $false For each unconfigured MailBox of type Resource Mailboxes, Public Folder Mailboxes or DiscoverySea",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/microsoft-365/compliance/audit-mailboxes?view=o365-worldwide"
  },
  {
    "Number": "75",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "exo_mailtipsenabled",
    "Description": "Ensure MailTips are enabled for end users",
    "Remediation": "To enable MailTips, use the Exchange Online PowerShell Module:  Run Microsoft Exchange Online PowerShell Module Connect using &quot;Connect-ExchangeOnline&quot; Run the following PowerShell command:  Set-OrganizationConfig -MailTipsAllTipsEnabled $true -Ma",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/exchange/clients-and-mobile-in-exchange-online/mailtips/mailtips"
  },
  {
    "Number": "76",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_complex_password_simple_password_blocked",
    "Description": "Ensure that mobile devices require complex passwords (Simple Passwords = Blocked)",
    "Remediation": "To set mobile device management profiles, use the Microsoft Intune admin center  Select , then under select Configuration profiles&nbsp; If there are no policies, select Create Policy.  Set a for the policy, choose MacOS in the and under Profile type selec",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "77",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_password_reused_prohibited",
    "Description": "Ensure that mobile device password reuse is prohibited",
    "Remediation": "To set mobile device password reuse is prohibited, go to the Microsoft Intune admin center  Select and then under select Configuration profiles. If there are no configurations -  select Create profile. Set a for the policy, choose the appropriate and selec",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-restrictions-configure"
  },
  {
    "Number": "78",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "exo_oauth2clientprofileenabled",
    "Description": "Ensure modern authentication for Exchange Online is enabled",
    "Remediation": "To enable modern authentication, use the Exchange Online PowerShell Module:  Run the Microsoft Exchange Online PowerShell Module. Connect to Exchange Online using \"Connect-ExchangeOnline.\" Run the following PowerShell command: Set-OrganizationConfig -OAuth",
    "Resource": "MS365 Tenant",
    "MoreInfo": ""
  },
  {
    "Number": "79",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "exo_outlookaddins",
    "Description": "Ensure users installing Outlook add-ins is not allowed",
    "Remediation": "To prohibit users installing Outlook add-ins:  Navigate to Exchange admin center https://admin.exchange.microsoft.com Click to expand  select User roles Select Default Role Assignment Policy In the properties pane on the right click on Manage permissions U",
    "Resource": "MS365 Tenant",
    "MoreInfo": ""
  },
  {
    "Number": "80",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_AV_firewall_enabled",
    "Description": "Ensure that devices connecting have AV and a local firewall enabled",
    "Remediation": "To ensure that devices connecting have AV and a local firewall enabled, use the Microsoft Intune admin center  Select Endpoint Manager under Admin Centers Select , then under select   If there are no policies, select Create Policy.  Set a for the policy, c",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "81",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_conection_from_jail_broken_rooted_devices",
    "Description": "Ensure that users cannot connect from devices that are jail broken or rooted",
    "Remediation": "To ensure that users cannot connect from devices that are jail broken or rooted, use the Microsoft Intune admin center  Select , then under select   If there are no policies, select Create Policy.  Set a for the policy, choose the appropriate&nbsp; Under a",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "82",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_advanced_security_configuration",
    "Description": "Ensure mobile device management policies are set to require advanced security configurations",
    "Remediation": "To set mobile device management profiles, use the Microsoft Intune admin center  Select and then under select Configuration profiles&nbsp; Select Create profile to create a new profile. Select the appropriate Platform ( or ).  Choose, based on your organiz",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "83",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_complex_password_alphanumeric",
    "Description": "Ensure that mobile devices require complex passwords (Type = Alphanumeric)",
    "Remediation": "To set mobile device complex password profiles, use the Microsoft Intune admin center  Select , then under select Configuration profiles&nbsp; If there are no policies, select Create Policy.  Set a for the policy, choose the appropriate and select  In the ",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "84",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_device_encryption",
    "Description": "Ensure that mobile device encryption is enabled to prevent unauthorized access to mobile data",
    "Remediation": "To set mobile device management profiles, use the Microsoft Intune admin center  Select , then under select Configuration profiles&nbsp; If there are no policies, select Create Policy.  Set a for the policy, choose the appropriate and select  In the Passwo",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "85",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_device_lock_after_inactivity",
    "Description": "Ensure devices lock after a period of inactivity to prevent unauthorized access",
    "Remediation": "To set mobile device management profiles, use the Microsoft Intune admin center  Select , then under select Configuration profiles&nbsp; If there are no policies, select Create Profile.  Set a for the policy, choose the appropriate and select  In the Passw",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "86",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_email_profiles_requirement",
    "Description": "Ensure mobile device management policies are required for email profiles - iOS/iPadOS only",
    "Remediation": "To set mobile device management profiles, use the Microsoft Intune admin center  Select , then under select Compliance policies For all the policies that are applied to \"iOS/iPadOS\" complete the following  Select the policy by clickin on its name. Under Ma",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "87",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_never_expires_password",
    "Description": "Ensure that mobile devices are set to never expire passwords",
    "Remediation": "To ensure that mobile devices are set to never expire passwords:  Use the Microsoft Intune admin center Select , then under  select Configuration profiles Review the list of profiles. From there, go to the device policies page to remove any device security",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "88",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_mobile_password_requirement",
    "Description": "Ensure mobile devices require the use of a password",
    "Remediation": "To set mobile device management profiles, use the Microsoft Intune admin center  Select , then under select Configuration profiles&nbsp; If there are no policies, select Create Policy.  Set a for the policy, choose the appropriate and under Profile type se",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "89",
    "Source": "MS365",
    "Priority": "3",
    "FindingName": "intune_wipe_on_multiple_signin_failures",
    "Description": "Ensure mobile devices are set to wipe on multiple sign-in failures to prevent brute force compromise",
    "Remediation": "To ensure mobile devices are set to wipe on multiple sign-in failures , use the Microsoft Intune admin center  Select , then under select Configuration profiles&nbsp; If there are no policies, select Create Policy.  Set a for the policy, choose the appropr",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://learn.microsoft.com/en-us/mem/intune/configuration/device-profile-create"
  },
  {
    "Number": "90",
    "Source": "MS365",
    "Priority": "2",
    "FindingName": "mdo_allowedsenderscombined",
    "Description": "Ensure that no sender domains are allowed for anti-spam policies",
    "Remediation": "Remove all allowed domains and allowed senders from all your inbound anti-spam policies.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antispam"
  },
  {
    "Number": "91",
    "Source": "MS365",
    "Priority": "1",
    "FindingName": "mdo_autoforwardingmode",
    "Description": "Set automatic email forwarding rules to be system controlled",
    "Remediation": "Ensure that all users have an assigned outbound anti-spam policy with the &lsquo;Automatic forwarding rules&rsquo; option set to recommended values which is &ldquo;Automatic – System-controlled&rdquo; or to &ldquo;Off - Forwarding is disabled&rdquo;, by ei",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antispam"
  },
  {
    "Number": "92",
    "Source": "MS365",
    "Priority": "1",
    "FindingName": "mdo_connectionfilter",
    "Description": "Don't add allowed IP addresses in the connection filter policy",
    "Remediation": "1. Open Anti-spam policies page in Microsoft 365 Defender portal  2. Remove all allowed IP addresses from the default connection filter policy",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antispam"
  },
  {
    "Number": "93",
    "Source": "MS365",
    "Priority": "1",
    "FindingName": "mdo_bulkthreshold",
    "Description": "Set the email bulk complaint level (BCL) threshold to be 6 or lower",
    "Remediation": "Ensure that all users have an assigned inbound anti-spam policy with the &lsquo;Bulk email spam action&rsquo; option enabled and the &lsquo;Bulk email threshold&rsquo; option set to 6 or lower, by either updating your existing policies or creating new ones",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/antispam"
  },
  {
    "Number": "94",
    "Source": "MS365",
    "Priority": "1",
    "FindingName": "AATP_Vpn",
    "Description": "Configure VPN integration",
    "Remediation": "Go to the Settings page, and configure the VPN radius accounting to enable VPN based detections.",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/settings/identities?tabid=radius"
  },
  {
    "Number": "95",
    "Source": "MS365",
    "Priority": "1",
    "FindingName": "AATP_HoneyToken",
    "Description": "Set a honeytoken account",
    "Remediation": "Go to the  Honeytoken Settings page, and set at least one honeytoken account.​",
    "Resource": "MS365 Tenant",
    "MoreInfo": "https://security.microsoft.com/settings/identities?tabid=entityTags"
  }
];

export const assetFindingsRows: assetFindingsSampleDataRow[] = [
  {
    "Number": "1",
    "Source": "CyberCheck",
    "Resource": "SVR10080",
    "Priority": "10",
    "FindingName": "CyberCheck_Unsupported_OS",
    "Category": "OS Support",
    "Description": "Asset detected is not running a supported OS",
    "SuggestedRemediation": "Apply updates or procure extended support for the OS"
  },
  {
    "Number": "2",
    "Source": "CyberCheck",
    "Resource": "LON10033",
    "Priority": "5",
    "FindingName": "CyberCheck_Inactive_Asset",
    "Category": "Asset Management",
    "Description": "Corporate owned device is not active, indicating it needs to be retired",
    "SuggestedRemediation": "Remove inactive device or set up scripts to age unused devices from directories"
  },
  {
    "Number": "3",
    "Source": "CyberCheck",
    "Resource": "SVR10091",
    "Priority": "5",
    "FindingName": "CyberCheck_Inactive_Asset",
    "Category": "Asset Management",
    "Description": "Corporate owned device is not active, indicating it needs to be retired",
    "SuggestedRemediation": "Remove inactive device or set up scripts to age unused devices from directories"
  },
  {
    "Number": "4",
    "Source": "CyberCheck",
    "Resource": "LON10055",
    "Priority": "5",
    "FindingName": "CyberCheck_Inactive_Asset",
    "Category": "Asset Management",
    "Description": "Corporate owned device is not active, indicating it needs to be retired",
    "SuggestedRemediation": "Remove inactive device or set up scripts to age unused devices from directories"
  },
  {
    "Number": "5",
    "Source": "CyberCheck",
    "Resource": "LON10012",
    "Priority": "7",
    "FindingName": "CyberCheck_Disk_Encryption",
    "Category": "Asset Management",
    "Description": "Corporate owned device has one or more unencrypted disks",
    "SuggestedRemediation": "Enable data at rest encryption"
  },
  {
    "Number": "6",
    "Source": "CyberCheck",
    "Resource": "SVR10088",
    "Priority": "7",
    "FindingName": "CyberCheck_EDR_Coverage",
    "Category": "Asset Management",
    "Description": "Corporate owned device not covered by Endpoint Protection",
    "SuggestedRemediation": "Deploy endpoint protection agent"
  },
  {
    "Number": "7",
    "Source": "CyberCheck",
    "Resource": "LON10062",
    "Priority": "7",
    "FindingName": "CyberCheck_EDR_Active",
    "Category": "Asset Management",
    "Description": "Corporate owned device has Endpoint Protection installed, but it is inactive or out of date",
    "SuggestedRemediation": "Enable endpoint protection and turn on automatic updates"
  },
  {
    "Number": "8",
    "Source": "CyberCheck",
    "Resource": "LON10018",
    "Priority": "7",
    "FindingName": "CyberCheck_MDM_Coverage",
    "Category": "Asset Management",
    "Description": "Corporate owned device not MDM managed",
    "SuggestedRemediation": "Enroll asset with MDM tool"
  },
  {
    "Number": "9",
    "Source": "CyberCheck",
    "Resource": "LON10021",
    "Priority": "7",
    "FindingName": "CyberCheck_MDM_Compliance",
    "Category": "Asset Management",
    "Description": "Corporate owned device reported as non-compliant by MDM tool",
    "SuggestedRemediation": "See MDM compliance failure report"
  },
  {
    "Number": "10",
    "Source": "Microsoft",
    "Resource": "LON10072",
    "Priority": "9",
    "FindingName": "sca-_-scid-2100",
    "Category": "Firmware - Windows Server 2022",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable UEFI Secure Boot mode"
  },
  {
    "Number": "11",
    "Source": "Microsoft",
    "Resource": "LON10042",
    "Priority": "5",
    "FindingName": "sca-_-scid-10002",
    "Category": "Network - Defender",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Remove insecure administration protocols SNMP V1 and SNMP V2"
  },
  {
    "Number": "12",
    "Source": "Microsoft",
    "Resource": "SVR10085",
    "Priority": "8",
    "FindingName": "sca-_-scid-24",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Remote Desktop security level' to 'TLS'"
  },
  {
    "Number": "13",
    "Source": "Microsoft",
    "Resource": "LON10034",
    "Priority": "5",
    "FindingName": "sca-_-scid-45",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set user authentication for remote connections by using Network Level Authentication to 'Enabled'"
  },
  {
    "Number": "14",
    "Source": "Microsoft",
    "Resource": "LON10054",
    "Priority": "8",
    "FindingName": "sca-_-scid-53",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable SMBv1 client driver"
  },
  {
    "Number": "15",
    "Source": "Microsoft",
    "Resource": "LON10015",
    "Priority": "8",
    "FindingName": "sca-_-scid-54",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable SMBv1 server"
  },
  {
    "Number": "16",
    "Source": "Microsoft",
    "Resource": "LON10041",
    "Priority": "5",
    "FindingName": "sca-_-scid-58",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Installation and configuration of Network Bridge on your DNS domain network'"
  },
  {
    "Number": "17",
    "Source": "Microsoft",
    "Resource": "SVR10080",
    "Priority": "2",
    "FindingName": "sca-_-scid-59",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Require domain users to elevate when setting a network's location'"
  },
  {
    "Number": "18",
    "Source": "Microsoft",
    "Resource": "LON10010",
    "Priority": "5",
    "FindingName": "sca-_-scid-60",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Prohibit use of Internet Connection Sharing on your DNS domain network"
  },
  {
    "Number": "19",
    "Source": "Microsoft",
    "Resource": "LON10058",
    "Priority": "8",
    "FindingName": "sca-_-scid-72",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set LAN Manager authentication level to 'Send NTLMv2 response only. Refuse LM & NTLM'"
  },
  {
    "Number": "20",
    "Source": "Microsoft",
    "Resource": "LON10056",
    "Priority": "5",
    "FindingName": "sca-_-scid-81",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set IPv6 source routing to highest protection"
  },
  {
    "Number": "21",
    "Source": "Microsoft",
    "Resource": "LON10052",
    "Priority": "5",
    "FindingName": "sca-_-scid-82",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable IP source routing"
  },
  {
    "Number": "22",
    "Source": "Microsoft",
    "Resource": "LON10037",
    "Priority": "5",
    "FindingName": "sca-_-scid-95",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Microsoft network client: Digitally sign communications (always)'"
  },
  {
    "Number": "23",
    "Source": "Microsoft",
    "Resource": "LON10013",
    "Priority": "8",
    "FindingName": "sca-_-scid-96",
    "Category": "Network - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Network Protection'"
  },
  {
    "Number": "24",
    "Source": "Microsoft",
    "Resource": "SVR10088",
    "Priority": "8",
    "FindingName": "sca-_-scid-64",
    "Category": "Network - Windows 10",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Restrict anonymous access to named pipes and Shares"
  },
  {
    "Number": "25",
    "Source": "Microsoft",
    "Resource": "LON10002",
    "Priority": "8",
    "FindingName": "sca-_-scid-65",
    "Category": "Network - Windows 10",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Store LAN Manager hash value on next password change'"
  },
  {
    "Number": "26",
    "Source": "Microsoft",
    "Resource": "LON10070",
    "Priority": "5",
    "FindingName": "sca-_-scid-94",
    "Category": "Network - Windows 10",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable sending unencrypted password to third-party SMB servers"
  },
  {
    "Number": "27",
    "Source": "Microsoft",
    "Resource": "LON10074",
    "Priority": "7",
    "FindingName": "sca-_-scid-5006",
    "Category": "OS - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set account lockout threshold to 5 or lower in macOS"
  },
  {
    "Number": "28",
    "Source": "Microsoft",
    "Resource": "LON10047",
    "Priority": "6",
    "FindingName": "sca-_-scid-5014",
    "Category": "OS - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Secure Home Folders in macOS"
  },
  {
    "Number": "29",
    "Source": "Microsoft",
    "Resource": "SVR10082",
    "Priority": "8",
    "FindingName": "sca-_-scid-102",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Local Security Authority (LSA) protection' on Windows 11 22h2 and higher"
  },
  {
    "Number": "30",
    "Source": "Microsoft",
    "Resource": "LON10068",
    "Priority": "8",
    "FindingName": "sca-_-scid-25",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Local Security Authority (LSA) protection'"
  },
  {
    "Number": "31",
    "Source": "Microsoft",
    "Resource": "LON10025",
    "Priority": "8",
    "FindingName": "sca-_-scid-27",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set User Account Control (UAC) to automatically deny elevation requests"
  },
  {
    "Number": "32",
    "Source": "Microsoft",
    "Resource": "SVR10096",
    "Priority": "5",
    "FindingName": "sca-_-scid-28",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Interactive logon: Machine inactivity limit' to '1-900 seconds'"
  },
  {
    "Number": "33",
    "Source": "Microsoft",
    "Resource": "LON10001",
    "Priority": "8",
    "FindingName": "sca-_-scid-29",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Enumerate administrator accounts on elevation'"
  },
  {
    "Number": "34",
    "Source": "Microsoft",
    "Resource": "LON10014",
    "Priority": "8",
    "FindingName": "sca-_-scid-3001",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix unquoted service path for Windows services"
  },
  {
    "Number": "35",
    "Source": "Microsoft",
    "Resource": "LON10005",
    "Priority": "8",
    "FindingName": "sca-_-scid-3002",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Change service executable path to a common protected location"
  },
  {
    "Number": "36",
    "Source": "Microsoft",
    "Resource": "LON10017",
    "Priority": "8",
    "FindingName": "sca-_-scid-3003",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Change service account to avoid cached password in windows registry"
  },
  {
    "Number": "37",
    "Source": "Microsoft",
    "Resource": "SVR10089",
    "Priority": "8",
    "FindingName": "sca-_-scid-4000",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disallow offline access to shares"
  },
  {
    "Number": "38",
    "Source": "Microsoft",
    "Resource": "LON10040",
    "Priority": "8",
    "FindingName": "sca-_-scid-4001",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Remove share write permission set to ‘Everyone’"
  },
  {
    "Number": "39",
    "Source": "Microsoft",
    "Resource": "SVR10092",
    "Priority": "8",
    "FindingName": "sca-_-scid-4002",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Remove shares from the root folder"
  },
  {
    "Number": "40",
    "Source": "Microsoft",
    "Resource": "LON10055",
    "Priority": "8",
    "FindingName": "sca-_-scid-4003",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set folder access-based enumeration for shares"
  },
  {
    "Number": "41",
    "Source": "Microsoft",
    "Resource": "LON10027",
    "Priority": "5",
    "FindingName": "sca-_-scid-52",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Apply UAC restrictions to local accounts on network logons'"
  },
  {
    "Number": "42",
    "Source": "Microsoft",
    "Resource": "SVR10087",
    "Priority": "5",
    "FindingName": "sca-_-scid-61",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Minimum PIN length for startup' to '6 or more characters'"
  },
  {
    "Number": "43",
    "Source": "Microsoft",
    "Resource": "SVR10086",
    "Priority": "8",
    "FindingName": "sca-_-scid-62",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Require additional authentication at startup'"
  },
  {
    "Number": "44",
    "Source": "Microsoft",
    "Resource": "LON10066",
    "Priority": "5",
    "FindingName": "sca-_-scid-63",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Configure Offer Remote Assistance'"
  },
  {
    "Number": "45",
    "Source": "Microsoft",
    "Resource": "LON10032",
    "Priority": "5",
    "FindingName": "sca-_-scid-67",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Autoplay for non-volume devices'"
  },
  {
    "Number": "46",
    "Source": "Microsoft",
    "Resource": "LON10028",
    "Priority": "8",
    "FindingName": "sca-_-scid-69",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Autoplay' for all drives"
  },
  {
    "Number": "47",
    "Source": "Microsoft",
    "Resource": "LON10045",
    "Priority": "8",
    "FindingName": "sca-_-scid-70",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set default behavior for 'AutoRun' to 'Enabled: Do not execute any autorun commands'"
  },
  {
    "Number": "48",
    "Source": "Microsoft",
    "Resource": "SVR10099",
    "Priority": "8",
    "FindingName": "sca-_-scid-73",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Allow Basic authentication' for WinRM Client"
  },
  {
    "Number": "49",
    "Source": "Microsoft",
    "Resource": "SVR10100",
    "Priority": "8",
    "FindingName": "sca-_-scid-74",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Allow Basic authentication' for WinRM Service"
  },
  {
    "Number": "50",
    "Source": "Microsoft",
    "Resource": "LON10024",
    "Priority": "8",
    "FindingName": "sca-_-scid-87",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable Solicited Remote Assistance"
  },
  {
    "Number": "51",
    "Source": "Microsoft",
    "Resource": "LON10049",
    "Priority": "8",
    "FindingName": "sca-_-scid-88",
    "Category": "OS - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable Anonymous enumeration of shares"
  },
  {
    "Number": "52",
    "Source": "Microsoft",
    "Resource": "SVR10090",
    "Priority": "5",
    "FindingName": "sca-_-scid-37",
    "Category": "OS - Windows 10",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Domain member: Digitally encrypt or sign secure channel data (always)'"
  },
  {
    "Number": "53",
    "Source": "Microsoft",
    "Resource": "LON10043",
    "Priority": "5",
    "FindingName": "sca-_-scid-39",
    "Category": "OS - Windows 10",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Domain member: Digitally sign secure channel data (when possible)'"
  },
  {
    "Number": "54",
    "Source": "Microsoft",
    "Resource": "LON10035",
    "Priority": "8",
    "FindingName": "sca-_-scid-68",
    "Category": "OS - Windows 10",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Anonymous enumeration of SAM accounts'"
  },
  {
    "Number": "55",
    "Source": "Microsoft",
    "Resource": "LON10063",
    "Priority": "5",
    "FindingName": "sca-_-scid-36",
    "Category": "OS - Windows Server 2012 R2",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Domain member: Require strong (Windows 2000 or later) session key'"
  },
  {
    "Number": "56",
    "Source": "Microsoft",
    "Resource": "LON10026",
    "Priority": "5",
    "FindingName": "sca-_-scid-38",
    "Category": "OS - Windows Server 2022",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable Set 'Domain member: Digitally encrypt secure channel data (when possible)'"
  },
  {
    "Number": "57",
    "Source": "Microsoft",
    "Resource": "LON10048",
    "Priority": "9",
    "FindingName": "sca-_-scid-20000",
    "Category": "Security controls -",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Onboard devices to Microsoft Defender for Endpoint"
  },
  {
    "Number": "58",
    "Source": "Microsoft",
    "Resource": "LON10023",
    "Priority": "10",
    "FindingName": "sca-_-scid-6001",
    "Category": "Security controls - Linux",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix Microsoft Defender for Endpoint sensor data collection for Linux"
  },
  {
    "Number": "59",
    "Source": "Microsoft",
    "Resource": "LON10008",
    "Priority": "10",
    "FindingName": "sca-_-scid-6002",
    "Category": "Security controls - Linux",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix Microsoft Defender for Endpoint impaired communications for Linux"
  },
  {
    "Number": "60",
    "Source": "Microsoft",
    "Resource": "SVR10095",
    "Priority": "10",
    "FindingName": "sca-_-scid-6090",
    "Category": "Security controls - Linux",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender Antivirus real-time protection for Linux"
  },
  {
    "Number": "61",
    "Source": "Microsoft",
    "Resource": "LON10006",
    "Priority": "9",
    "FindingName": "sca-_-scid-6091",
    "Category": "Security controls - Linux",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender Antivirus PUA protection in block mode for Linux"
  },
  {
    "Number": "62",
    "Source": "Microsoft",
    "Resource": "LON10007",
    "Priority": "9",
    "FindingName": "sca-_-scid-6095",
    "Category": "Security controls - Linux",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Update Microsoft Defender Antivirus definitions for Linux"
  },
  {
    "Number": "63",
    "Source": "Microsoft",
    "Resource": "LON10021",
    "Priority": "10",
    "FindingName": "sca-_-scid-5001",
    "Category": "Security controls - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix Microsoft Defender for Endpoint sensor data collection in macOS"
  },
  {
    "Number": "64",
    "Source": "Microsoft",
    "Resource": "LON10020",
    "Priority": "10",
    "FindingName": "sca-_-scid-5002",
    "Category": "Security controls - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix Microsoft Defender for Endpoint impaired communications in macOS"
  },
  {
    "Number": "65",
    "Source": "Microsoft",
    "Resource": "LON10078",
    "Priority": "10",
    "FindingName": "sca-_-scid-5007",
    "Category": "Security controls - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Firewall in macOS"
  },
  {
    "Number": "66",
    "Source": "Microsoft",
    "Resource": "LON10039",
    "Priority": "7",
    "FindingName": "sca-_-scid-5011",
    "Category": "Security controls - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable FileVault Disk Encryption in macOS"
  },
  {
    "Number": "67",
    "Source": "Microsoft",
    "Resource": "LON10067",
    "Priority": "9",
    "FindingName": "sca-_-scid-5091",
    "Category": "Security controls - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender Antivirus PUA protection in block mode in macOS"
  },
  {
    "Number": "68",
    "Source": "Microsoft",
    "Resource": "LON10003",
    "Priority": "8",
    "FindingName": "sca-_-scid-5092",
    "Category": "Security controls - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Tamper Protection for MacOS"
  },
  {
    "Number": "69",
    "Source": "Microsoft",
    "Resource": "SVR10084",
    "Priority": "9",
    "FindingName": "sca-_-scid-5095",
    "Category": "Security controls - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Update Microsoft Defender Antivirus definitions in macOS"
  },
  {
    "Number": "70",
    "Source": "Microsoft",
    "Resource": "LON10077",
    "Priority": "10",
    "FindingName": "sca-_-scid-2000",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender for Endpoint sensor"
  },
  {
    "Number": "71",
    "Source": "Microsoft",
    "Resource": "LON10064",
    "Priority": "10",
    "FindingName": "sca-_-scid-2001",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix Microsoft Defender for Endpoint sensor data collection"
  },
  {
    "Number": "72",
    "Source": "Microsoft",
    "Resource": "LON10019",
    "Priority": "10",
    "FindingName": "sca-_-scid-2002",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix Microsoft Defender for Endpoint impaired communications"
  },
  {
    "Number": "73",
    "Source": "Microsoft",
    "Resource": "SVR10081",
    "Priority": "8",
    "FindingName": "sca-_-scid-2003",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Tamper Protection"
  },
  {
    "Number": "74",
    "Source": "Microsoft",
    "Resource": "LON10029",
    "Priority": "8",
    "FindingName": "sca-_-scid-2004",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable EDR in block mode"
  },
  {
    "Number": "75",
    "Source": "Microsoft",
    "Resource": "LON10038",
    "Priority": "10",
    "FindingName": "sca-_-scid-2010",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender Antivirus"
  },
  {
    "Number": "76",
    "Source": "Microsoft",
    "Resource": "LON10036",
    "Priority": "9",
    "FindingName": "sca-_-scid-2011",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Update Microsoft Defender Antivirus definitions"
  },
  {
    "Number": "77",
    "Source": "Microsoft",
    "Resource": "LON10018",
    "Priority": "10",
    "FindingName": "sca-_-scid-2012",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on real-time protection"
  },
  {
    "Number": "78",
    "Source": "Microsoft",
    "Resource": "LON10009",
    "Priority": "9",
    "FindingName": "sca-_-scid-2013",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on PUA protection in block mode"
  },
  {
    "Number": "79",
    "Source": "Microsoft",
    "Resource": "LON10050",
    "Priority": "8",
    "FindingName": "sca-_-scid-2014",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Fix Windows Defender Antivirus cloud service connectivity"
  },
  {
    "Number": "80",
    "Source": "Microsoft",
    "Resource": "LON10033",
    "Priority": "8",
    "FindingName": "sca-_-scid-2016",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable cloud-delivered protection"
  },
  {
    "Number": "81",
    "Source": "Microsoft",
    "Resource": "LON10012",
    "Priority": "8",
    "FindingName": "sca-_-scid-2021",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set controlled folder access to enabled or audit mode"
  },
  {
    "Number": "82",
    "Source": "Microsoft",
    "Resource": "LON10061",
    "Priority": "10",
    "FindingName": "sca-_-scid-2030",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Update Microsoft Defender for Endpoint core components"
  },
  {
    "Number": "83",
    "Source": "Microsoft",
    "Resource": "LON10053",
    "Priority": "8",
    "FindingName": "sca-_-scid-2051",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender Application Guard managed mode"
  },
  {
    "Number": "84",
    "Source": "Microsoft",
    "Resource": "LON10075",
    "Priority": "9",
    "FindingName": "sca-_-scid-2060",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set Microsoft Defender SmartScreen app and file checking to block or warn"
  },
  {
    "Number": "85",
    "Source": "Microsoft",
    "Resource": "LON10079",
    "Priority": "10",
    "FindingName": "sca-_-scid-2070",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender Firewall"
  },
  {
    "Number": "86",
    "Source": "Microsoft",
    "Resource": "LON10076",
    "Priority": "9",
    "FindingName": "sca-_-scid-2071",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Secure Microsoft Defender Firewall domain profile"
  },
  {
    "Number": "87",
    "Source": "Microsoft",
    "Resource": "LON10071",
    "Priority": "9",
    "FindingName": "sca-_-scid-2072",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Secure Microsoft Defender firewall private profile"
  },
  {
    "Number": "88",
    "Source": "Microsoft",
    "Resource": "LON10069",
    "Priority": "9",
    "FindingName": "sca-_-scid-2073",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Secure Microsoft Defender Firewall public profile"
  },
  {
    "Number": "89",
    "Source": "Microsoft",
    "Resource": "LON10060",
    "Priority": "8",
    "FindingName": "sca-_-scid-2080",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn on Microsoft Defender Credential Guard"
  },
  {
    "Number": "90",
    "Source": "Microsoft",
    "Resource": "LON10059",
    "Priority": "9",
    "FindingName": "sca-_-scid-2090",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Encrypt all BitLocker-supported drives"
  },
  {
    "Number": "91",
    "Source": "Microsoft",
    "Resource": "SVR10094",
    "Priority": "9",
    "FindingName": "sca-_-scid-2091",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Resume BitLocker protection on all drives"
  },
  {
    "Number": "92",
    "Source": "Microsoft",
    "Resource": "LON10046",
    "Priority": "8",
    "FindingName": "sca-_-scid-2093",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Ensure BitLocker drive compatibility"
  },
  {
    "Number": "93",
    "Source": "Microsoft",
    "Resource": "LON10065",
    "Priority": "9",
    "FindingName": "sca-_-scid-2500",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block executable content from email client and webmail"
  },
  {
    "Number": "94",
    "Source": "Microsoft",
    "Resource": "LON10057",
    "Priority": "9",
    "FindingName": "sca-_-scid-2501",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block all Office applications from creating child processes"
  },
  {
    "Number": "95",
    "Source": "Microsoft",
    "Resource": "SVR10091",
    "Priority": "9",
    "FindingName": "sca-_-scid-2502",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block Office applications from creating executable content"
  },
  {
    "Number": "96",
    "Source": "Microsoft",
    "Resource": "SVR10098",
    "Priority": "9",
    "FindingName": "sca-_-scid-2503",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block Office applications from injecting code into other processes"
  },
  {
    "Number": "97",
    "Source": "Microsoft",
    "Resource": "LON10030",
    "Priority": "9",
    "FindingName": "sca-_-scid-2504",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block JavaScript or VBScript from launching downloaded executable content"
  },
  {
    "Number": "98",
    "Source": "Microsoft",
    "Resource": "SVR10093",
    "Priority": "9",
    "FindingName": "sca-_-scid-2505",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block execution of potentially obfuscated scripts"
  },
  {
    "Number": "99",
    "Source": "Microsoft",
    "Resource": "LON10073",
    "Priority": "9",
    "FindingName": "sca-_-scid-2506",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block Win32 API calls from Office macros"
  },
  {
    "Number": "100",
    "Source": "Microsoft",
    "Resource": "LON10004",
    "Priority": "9",
    "FindingName": "sca-_-scid-2507",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block executable files from running unless they meet a prevalence, age, or trusted list criterion"
  },
  {
    "Number": "101",
    "Source": "Microsoft",
    "Resource": "LON10011",
    "Priority": "9",
    "FindingName": "sca-_-scid-2508",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Use advanced protection against ransomware"
  },
  {
    "Number": "102",
    "Source": "Microsoft",
    "Resource": "LON10044",
    "Priority": "9",
    "FindingName": "sca-_-scid-2509",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block credential stealing from the Windows local security authority subsystem (lsass.exe)"
  },
  {
    "Number": "103",
    "Source": "Microsoft",
    "Resource": "SVR10083",
    "Priority": "9",
    "FindingName": "sca-_-scid-2510",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block process creations originating from PSExec and WMI commands"
  },
  {
    "Number": "104",
    "Source": "Microsoft",
    "Resource": "SVR10097",
    "Priority": "9",
    "FindingName": "sca-_-scid-2511",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block untrusted and unsigned processes that run from USB"
  },
  {
    "Number": "105",
    "Source": "Microsoft",
    "Resource": "LON10031",
    "Priority": "9",
    "FindingName": "sca-_-scid-2512",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block Office communication application from creating child processes"
  },
  {
    "Number": "106",
    "Source": "Microsoft",
    "Resource": "LON10062",
    "Priority": "9",
    "FindingName": "sca-_-scid-2513",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block Adobe Reader from creating child processes"
  },
  {
    "Number": "107",
    "Source": "Microsoft",
    "Resource": "LON10051",
    "Priority": "9",
    "FindingName": "sca-_-scid-2514",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block persistence through WMI event subscription"
  },
  {
    "Number": "108",
    "Source": "Microsoft",
    "Resource": "LON10022",
    "Priority": "9",
    "FindingName": "sca-_-scid-2515",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Block abuse of exploited vulnerable signed drivers"
  },
  {
    "Number": "109",
    "Source": "Microsoft",
    "Resource": "LON10016",
    "Priority": "2",
    "FindingName": "sca-_-scid-43",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable Microsoft Defender Firewall notifications when programs are blocked for Domain profile"
  },
  {
    "Number": "110",
    "Source": "Microsoft",
    "Resource": "LON10072",
    "Priority": "2",
    "FindingName": "sca-_-scid-46",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable Microsoft Defender Firewall notifications when programs are blocked for Private profile"
  },
  {
    "Number": "111",
    "Source": "Microsoft",
    "Resource": "LON10042",
    "Priority": "2",
    "FindingName": "sca-_-scid-49",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable Microsoft Defender Firewall notifications when programs are blocked for Public profile"
  },
  {
    "Number": "112",
    "Source": "Microsoft",
    "Resource": "SVR10085",
    "Priority": "5",
    "FindingName": "sca-_-scid-51",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable merging of local Microsoft Defender Firewall connection rules with group policy firewall rules for the Public profile"
  },
  {
    "Number": "113",
    "Source": "Microsoft",
    "Resource": "LON10034",
    "Priority": "5",
    "FindingName": "sca-_-scid-6100",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Microsoft Defender for Endpoint Plug-in for WSL'"
  },
  {
    "Number": "114",
    "Source": "Microsoft",
    "Resource": "LON10054",
    "Priority": "5",
    "FindingName": "sca-_-scid-6101",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Turn off custom kernel/commandline in Windows Subsystem for Linux"
  },
  {
    "Number": "115",
    "Source": "Microsoft",
    "Resource": "LON10015",
    "Priority": "8",
    "FindingName": "sca-_-scid-89",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable scanning of removable drives during a full scan"
  },
  {
    "Number": "116",
    "Source": "Microsoft",
    "Resource": "LON10041",
    "Priority": "9",
    "FindingName": "sca-_-scid-90",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable Microsoft Defender Antivirus email scanning"
  },
  {
    "Number": "117",
    "Source": "Microsoft",
    "Resource": "SVR10080",
    "Priority": "5",
    "FindingName": "sca-_-scid-91",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable Microsoft Defender Antivirus real-time behavior monitoring"
  },
  {
    "Number": "118",
    "Source": "Microsoft",
    "Resource": "LON10010",
    "Priority": "10",
    "FindingName": "sca-_-scid-92",
    "Category": "Security controls - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable Microsoft Defender Antivirus scanning of downloaded files and attachments"
  },
  {
    "Number": "119",
    "Source": "Microsoft",
    "Resource": "LON10015",
    "Priority": "6",
    "FindingName": "sca-_-scid-5003",
    "Category": "Accounts - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set minimum password length to 15 or more characters in macOS"
  },
  {
    "Number": "120",
    "Source": "Microsoft",
    "Resource": "SVR10086",
    "Priority": "5",
    "FindingName": "sca-_-scid-5004",
    "Category": "Accounts - Mac Os",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Enforce password history' to '24 or more password(s)' in macOS"
  },
  {
    "Number": "121",
    "Source": "Microsoft",
    "Resource": "SVR10088",
    "Priority": "8",
    "FindingName": "sca-_-scid-3010",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable the built-in Administrator account"
  },
  {
    "Number": "122",
    "Source": "Microsoft",
    "Resource": "LON10040",
    "Priority": "8",
    "FindingName": "sca-_-scid-3011",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable the built-in Guest account"
  },
  {
    "Number": "123",
    "Source": "Microsoft",
    "Resource": "LON10071",
    "Priority": "5",
    "FindingName": "sca-_-scid-32",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Minimum password length' to '14 or more characters'"
  },
  {
    "Number": "124",
    "Source": "Microsoft",
    "Resource": "LON10052",
    "Priority": "5",
    "FindingName": "sca-_-scid-33",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Enforce password history' to '24 or more password(s)'"
  },
  {
    "Number": "125",
    "Source": "Microsoft",
    "Resource": "LON10012",
    "Priority": "5",
    "FindingName": "sca-_-scid-35",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Minimum password age' to '1 or more day(s)'"
  },
  {
    "Number": "126",
    "Source": "Microsoft",
    "Resource": "SVR10084",
    "Priority": "6",
    "FindingName": "sca-_-scid-41",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Account lockout duration' to 15 minutes or more"
  },
  {
    "Number": "127",
    "Source": "Microsoft",
    "Resource": "SVR10094",
    "Priority": "6",
    "FindingName": "sca-_-scid-42",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Reset account lockout counter after' to 15 minutes or more"
  },
  {
    "Number": "128",
    "Source": "Microsoft",
    "Resource": "SVR10099",
    "Priority": "6",
    "FindingName": "sca-_-scid-44",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Set 'Account lockout threshold' to 1-10 invalid login attempts"
  },
  {
    "Number": "129",
    "Source": "Microsoft",
    "Resource": "LON10070",
    "Priority": "5",
    "FindingName": "sca-_-scid-84",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable Local Admin password management"
  },
  {
    "Number": "130",
    "Source": "Microsoft",
    "Resource": "SVR10092",
    "Priority": "5",
    "FindingName": "sca-_-scid-93",
    "Category": "Accounts - Windows",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable the local storage of passwords and credentials"
  },
  {
    "Number": "131",
    "Source": "Microsoft",
    "Resource": "LON10025",
    "Priority": "2",
    "FindingName": "sca-_-scid-40",
    "Category": "Accounts - Windows 10",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Disable 'Domain member: Disable machine account password changes'"
  },
  {
    "Number": "132",
    "Source": "Microsoft",
    "Resource": "LON10034",
    "Priority": "5",
    "FindingName": "sca-_-scid-71",
    "Category": "Accounts - Windows Server 2012 R2",
    "Description": "Not provided by vendor",
    "SuggestedRemediation": "Enable 'Limit local account use of blank passwords to console logon only'"
  }
];

export const accountFindingsRows: accountFindingsSampleDataRow[] = [
  {
    Source: 'CyberCheck',
    Resource: 'kendall.hogue@corporate.com',
    Priority: 10,
    FindingName: 'CyberCheck_PrivilegedUser_noMFA',
    Description: 'Account with an Administrative Role without MFA',
    SuggestedRemediation: 'Enforce MFA or remove the account, or access if no longer required'
  },
  {
    Source: 'CyberCheck',
    Resource: 'peyton.halverson@corporate.com',
    Priority: 8,
    FindingName: 'CyberCheck_MFA_Disabled',
    Description: 'Account without MFA enabled',
    SuggestedRemediation: 'Enforce MFA or disable the account if no longer required'
  },
  {
    Source: 'CyberCheck',
    Resource: 'anai.grimm@corporate.com',
    Priority: 8,
    FindingName: 'CyberCheck_MFA_Disabled',
    Description: 'Account without MFA enabled',
    SuggestedRemediation: 'Enforce MFA or disable the account if no longer required'
  },
  {
    Source: 'CyberCheck',
    Resource: 'shane.elliott@corporate.com',
    Priority: 7,
    FindingName: 'CyberCheck_Unused_Account_New',
    Description: 'Account has never been logged into after 60 days.',
    SuggestedRemediation: 'Consider if the account should be removed'
  },
  {
    Source: 'CyberCheck',
    Resource: 'keanu.sutton@corporate.com',
    Priority: 5,
    FindingName: 'CyberCheck_Unused_Account',
    Description: 'Account not used in the last 60 days',
    SuggestedRemediation: 'Consider if the account should be removed'
  },
  {
    Source: 'CyberCheck',
    Resource: 'blair.crews@corporate.com',
    Priority: 5,
    FindingName: 'CyberCheck_Unused_Account',
    Description: 'Account not used in the last 60 days',
    SuggestedRemediation: 'Consider if the account should be removed'
  },
  {
    Source: 'CyberCheck',
    Resource: 'milton.wooten@corporate.com',
    Priority: 5,
    FindingName: 'CyberCheck_Unused_Account',
    Description: 'Account not used in the last 60 days',
    SuggestedRemediation: 'Consider if the account should be removed'
  }
];

export const accountsRows: accountsSampleDataRow[] = [
     {
       "Source": "EntraID",
       "Firstname": "Kendall",
       "Lastname": "Hogue",
       "Email": "kendall.hogue@corporate.com",
       "LastActivity": "12/11/2024 14:39:27",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Global Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Braxton",
       "Lastname": "Frederick",
       "Email": "braxton.frederick@corporate.com",
       "LastActivity": "04/11/2024 13:36:27",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Global Administrator, Intune Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Shyanne",
       "Lastname": "Weinberg",
       "Email": "shyanne.weinberg@corporate.com",
       "LastActivity": "09/11/2024 09:08:03",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Intune Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Pranav",
       "Lastname": "Ritter",
       "Email": "pranav.ritter@corporate.com",
       "LastActivity": "01/11/2024 23:24:27",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Global Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alexia",
       "Lastname": "Flannery",
       "Email": "alexia.flannery@corporate.com",
       "LastActivity": "01/11/2024 11:42:54",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Exchange Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Enoch",
       "Lastname": "Haag",
       "Email": "enoch.haag@corporate.com",
       "LastActivity": "07/11/2024 20:29:22",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Intune Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jose",
       "Lastname": "Gilbertson",
       "Email": "jose.gilbertson@corporate.com",
       "LastActivity": "08/12/2024 12:20:07",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Azure AD Joined Device Local Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kaley",
       "Lastname": "Whitehead",
       "Email": "kaley.whitehead@corporate.com",
       "LastActivity": "03/11/2024 12:26:17",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Exchange Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Heriberto",
       "Lastname": "Sabo",
       "Email": "heriberto.sabo@corporate.com",
       "LastActivity": "15/11/2024 09:07:13",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "User Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ellis",
       "Lastname": "Calvert",
       "Email": "ellis.calvert@corporate.com",
       "LastActivity": "07/12/2024 19:50:23",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Authentication Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Giavanna",
       "Lastname": "Myrick",
       "Email": "giavanna.myrick@corporate.com",
       "LastActivity": "12/11/2024 06:12:16",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Azure AD Joined Device Local Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Blake",
       "Lastname": "Martz",
       "Email": "blake.martz@corporate.com",
       "LastActivity": "04/12/2024 01:41:15",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Global Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cristopher",
       "Lastname": "Frost",
       "Email": "cristopher.frost@corporate.com",
       "LastActivity": "08/12/2024 11:59:57",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Exchange Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Harley",
       "Lastname": "Root",
       "Email": "harley.root@corporate.com",
       "LastActivity": "06/12/2024 21:20:16",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Authentication Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mireya",
       "Lastname": "Spears",
       "Email": "mireya.spears@corporate.com",
       "LastActivity": "22/11/2024 23:07:24",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Exchange Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dezmond",
       "Lastname": "Brown",
       "Email": "dezmond.brown@corporate.com",
       "LastActivity": "03/11/2024 06:49:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "User Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Gavin",
       "Lastname": "Dodd",
       "Email": "gavin.dodd@corporate.com",
       "LastActivity": "12/11/2024 11:05:25",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Global Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dwight",
       "Lastname": "Isaac",
       "Email": "dwight.isaac@corporate.com",
       "LastActivity": "05/12/2024 03:38:56",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Security Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kathleen",
       "Lastname": "Coronado",
       "Email": "kathleen.coronado@corporate.com",
       "LastActivity": "20/11/2024 15:30:50",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Security Operator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alea",
       "Lastname": "Headley",
       "Email": "alea.headley@corporate.com",
       "LastActivity": "10/11/2024 21:03:37",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Security Reader"
     },
     {
       "Source": "EntraID",
       "Firstname": "Milton",
       "Lastname": "Wooten",
       "Email": "milton.wooten@corporate.com",
       "LastActivity": "10/04/2024 12:58:41",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "SharePoint Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Julien",
       "Lastname": "Fleming",
       "Email": "julien.fleming@corporate.com",
       "LastActivity": "07/11/2024 10:51:32",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Skype for Business Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Juliann",
       "Lastname": "Booker",
       "Email": "juliann.booker@corporate.com",
       "LastActivity": "27/11/2024 02:52:18",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Teams Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Serina",
       "Lastname": "Jaramillo",
       "Email": "serina.jaramillo@corporate.com",
       "LastActivity": "08/12/2024 05:58:49",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Teams Communications Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jaelyn",
       "Lastname": "Sweat",
       "Email": "jaelyn.sweat@corporate.com",
       "LastActivity": "27/11/2024 18:23:19",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Usage Summary Reports Reader"
     },
     {
       "Source": "EntraID",
       "Firstname": "Victor",
       "Lastname": "Moulton",
       "Email": "victor.moulton@corporate.com",
       "LastActivity": "02/12/2024 01:37:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Billing Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rebekah",
       "Lastname": "Chan",
       "Email": "rebekah.chan@corporate.com",
       "LastActivity": "01/12/2024 04:32:09",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Compliance Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jaclyn",
       "Lastname": "Vitale",
       "Email": "jaclyn.vitale@corporate.com",
       "LastActivity": "21/11/2024 07:35:41",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Compliance Data Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rylee",
       "Lastname": "Hardwick",
       "Email": "rylee.hardwick@corporate.com",
       "LastActivity": "30/11/2024 09:23:45",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Directory Synchronization Accounts"
     },
     {
       "Source": "EntraID",
       "Firstname": "Denver",
       "Lastname": "Dobbins",
       "Email": "denver.dobbins@corporate.com",
       "LastActivity": "17/11/2024 05:21:56",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Exchange Recipient Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dimitri",
       "Lastname": "Embry",
       "Email": "dimitri.embry@corporate.com",
       "LastActivity": "22/11/2024 14:02:23",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Global Reader"
     },
     {
       "Source": "EntraID",
       "Firstname": "Bradly",
       "Lastname": "Lange",
       "Email": "bradly.lange@corporate.com",
       "LastActivity": "20/11/2024 18:48:13",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Helpdesk Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Gino",
       "Lastname": "Paz",
       "Email": "gino.paz@corporate.com",
       "LastActivity": "28/11/2024 12:22:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Intune Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Antonia",
       "Lastname": "Brock",
       "Email": "antonia.brock@corporate.com",
       "LastActivity": "11/11/2024 17:53:32",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Privileged Role Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Citlalli",
       "Lastname": "Burge",
       "Email": "citlalli.burge@corporate.com",
       "LastActivity": "06/11/2024 12:52:59",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Reports Reader"
     },
     {
       "Source": "EntraID",
       "Firstname": "Sherman",
       "Lastname": "Deloach",
       "Email": "sherman.deloach@corporate.com",
       "LastActivity": "28/11/2024 07:42:25",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "Security Reader"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tierra",
       "Lastname": "Maher",
       "Email": "tierra.maher@corporate.com",
       "LastActivity": "02/12/2024 21:33:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "Billing Administrator"
     },
     {
       "Source": "EntraID",
       "Firstname": "Blake",
       "Lastname": "Dupont",
       "Email": "blake.dupont@corporate.com",
       "LastActivity": "05/12/2024 10:43:42",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ibrahim",
       "Lastname": "Hatch",
       "Email": "ibrahim.hatch@corporate.com",
       "LastActivity": "10/12/2024 03:34:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Casey",
       "Lastname": "Buckner",
       "Email": "casey.buckner@corporate.com",
       "LastActivity": "27/11/2024 09:04:46",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alyson",
       "Lastname": "Ralston",
       "Email": "alyson.ralston@corporate.com",
       "LastActivity": "19/11/2024 06:01:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Niya",
       "Lastname": "Wren",
       "Email": "niya.wren@corporate.com",
       "LastActivity": "17/11/2024 02:33:30",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Abby",
       "Lastname": "Light",
       "Email": "abby.light@corporate.com",
       "LastActivity": "09/12/2024 23:46:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dylan",
       "Lastname": "Lowery",
       "Email": "dylan.lowery@corporate.com",
       "LastActivity": "02/11/2024 14:21:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Allyssa",
       "Lastname": "Reinhardt",
       "Email": "allyssa.reinhardt@corporate.com",
       "LastActivity": "01/11/2024 12:56:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Raekwon",
       "Lastname": "Pickering",
       "Email": "raekwon.pickering@corporate.com",
       "LastActivity": "20/11/2024 03:05:30",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Valery",
       "Lastname": "Massey",
       "Email": "valery.massey@corporate.com",
       "LastActivity": "02/12/2024 13:24:39",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Deontae",
       "Lastname": "Mehta",
       "Email": "deontae.mehta@corporate.com",
       "LastActivity": "28/11/2024 01:26:48",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Keven",
       "Lastname": "Albright",
       "Email": "keven.albright@corporate.com",
       "LastActivity": "07/12/2024 02:02:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marlon",
       "Lastname": "Calloway",
       "Email": "marlon.calloway@corporate.com",
       "LastActivity": "08/12/2024 05:42:05",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jonathon",
       "Lastname": "Altamirano",
       "Email": "jonathon.altamirano@corporate.com",
       "LastActivity": "19/11/2024 12:34:58",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dakotah",
       "Lastname": "Decker",
       "Email": "dakotah.decker@corporate.com",
       "LastActivity": "25/11/2024 19:48:40",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Priya",
       "Lastname": "Lange",
       "Email": "priya.lange@corporate.com",
       "LastActivity": "30/11/2024 11:54:02",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Zaire",
       "Lastname": "Lane",
       "Email": "zaire.lane@corporate.com",
       "LastActivity": "16/11/2024 19:11:11",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Broderick",
       "Lastname": "Reynoso",
       "Email": "broderick.reynoso@corporate.com",
       "LastActivity": "08/11/2024 22:05:47",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ella",
       "Lastname": "Wadsworth",
       "Email": "ella.wadsworth@corporate.com",
       "LastActivity": "12/11/2024 11:59:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Douglas",
       "Lastname": "Pollard",
       "Email": "douglas.pollard@corporate.com",
       "LastActivity": "30/11/2024 17:11:12",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Magaly",
       "Lastname": "McNeil",
       "Email": "magaly.mcneil@corporate.com",
       "LastActivity": "04/12/2024 14:59:28",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Robin",
       "Lastname": "Saucedo",
       "Email": "robin.saucedo@corporate.com",
       "LastActivity": "13/11/2024 16:30:18",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Leonardo",
       "Lastname": "Villa",
       "Email": "leonardo.villa@corporate.com",
       "LastActivity": "04/12/2024 19:04:37",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Luiz",
       "Lastname": "Persaud",
       "Email": "luiz.persaud@corporate.com",
       "LastActivity": "30/11/2024 17:28:04",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jackson",
       "Lastname": "Foltz",
       "Email": "jackson.foltz@corporate.com",
       "LastActivity": "10/12/2024 08:14:04",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alexus",
       "Lastname": "Strickland",
       "Email": "alexus.strickland@corporate.com",
       "LastActivity": "01/11/2024 05:28:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Zackery",
       "Lastname": "Fajardo",
       "Email": "zackery.fajardo@corporate.com",
       "LastActivity": "02/12/2024 07:24:43",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jermaine",
       "Lastname": "Sapp",
       "Email": "jermaine.sapp@corporate.com",
       "LastActivity": "13/11/2024 16:33:59",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Aubrie",
       "Lastname": "Lima",
       "Email": "aubrie.lima@corporate.com",
       "LastActivity": "16/11/2024 16:53:18",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Peyton",
       "Lastname": "Halverson",
       "Email": "peyton.halverson@corporate.com",
       "LastActivity": "12/11/2024 21:17:14",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Margarita",
       "Lastname": "Urban",
       "Email": "margarita.urban@corporate.com",
       "LastActivity": "08/11/2024 23:49:31",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Anai",
       "Lastname": "Grimm",
       "Email": "anai.grimm@corporate.com",
       "LastActivity": "07/12/2024 13:14:44",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kristal",
       "Lastname": "Boyd",
       "Email": "kristal.boyd@corporate.com",
       "LastActivity": "02/12/2024 09:26:51",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Shivani",
       "Lastname": "Sandoval",
       "Email": "shivani.sandoval@corporate.com",
       "LastActivity": "23/11/2024 12:27:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Naya",
       "Lastname": "Reimer",
       "Email": "naya.reimer@corporate.com",
       "LastActivity": "25/11/2024 00:49:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Callie",
       "Lastname": "Boone",
       "Email": "callie.boone@corporate.com",
       "LastActivity": "15/11/2024 10:05:11",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cyrus",
       "Lastname": "Bland",
       "Email": "cyrus.bland@corporate.com",
       "LastActivity": "03/12/2024 05:26:26",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Laken",
       "Lastname": "Kerns",
       "Email": "laken.kerns@corporate.com",
       "LastActivity": "29/11/2024 13:04:25",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dahlia",
       "Lastname": "Deleon",
       "Email": "dahlia.deleon@corporate.com",
       "LastActivity": "07/11/2024 02:59:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Heather",
       "Lastname": "Melendez",
       "Email": "heather.melendez@corporate.com",
       "LastActivity": "26/11/2024 05:23:42",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Katie",
       "Lastname": "Ferrara",
       "Email": "katie.ferrara@corporate.com",
       "LastActivity": "07/11/2024 19:07:09",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Maggie",
       "Lastname": "McCombs",
       "Email": "maggie.mccombs@corporate.com",
       "LastActivity": "08/11/2024 03:57:48",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jayce",
       "Lastname": "Warden",
       "Email": "jayce.warden@corporate.com",
       "LastActivity": "15/11/2024 08:03:50",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Pamela",
       "Lastname": "Fontenot",
       "Email": "pamela.fontenot@corporate.com",
       "LastActivity": "28/11/2024 10:59:31",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Sasha",
       "Lastname": "Pollard",
       "Email": "sasha.pollard@corporate.com",
       "LastActivity": "06/11/2024 22:40:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kiara",
       "Lastname": "Hamilton",
       "Email": "kiara.hamilton@corporate.com",
       "LastActivity": "13/11/2024 15:20:12",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Constance",
       "Lastname": "Dobbins",
       "Email": "constance.dobbins@corporate.com",
       "LastActivity": "01/11/2024 01:54:07",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mia",
       "Lastname": "Nickerson",
       "Email": "mia.nickerson@corporate.com",
       "LastActivity": "25/11/2024 00:42:55",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jude",
       "Lastname": "Jacobsen",
       "Email": "jude.jacobsen@corporate.com",
       "LastActivity": "24/11/2024 15:18:42",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Zion",
       "Lastname": "Avila",
       "Email": "zion.avila@corporate.com",
       "LastActivity": "02/11/2024 18:51:04",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Raymond",
       "Lastname": "Schmitt",
       "Email": "raymond.schmitt@corporate.com",
       "LastActivity": "03/11/2024 20:44:09",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Elliot",
       "Lastname": "Cruz",
       "Email": "elliot.cruz@corporate.com",
       "LastActivity": "27/11/2024 12:29:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Shane",
       "Lastname": "Elliott",
       "Email": "shane.elliott@corporate.com",
       "LastActivity": "-",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alexandria",
       "Lastname": "Goff",
       "Email": "alexandria.goff@corporate.com",
       "LastActivity": "02/12/2024 02:54:14",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kurtis",
       "Lastname": "Clay",
       "Email": "kurtis.clay@corporate.com",
       "LastActivity": "05/12/2024 20:05:42",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Keaton",
       "Lastname": "Clayton",
       "Email": "keaton.clayton@corporate.com",
       "LastActivity": "18/11/2024 08:49:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Hezekiah",
       "Lastname": "Esparza",
       "Email": "hezekiah.esparza@corporate.com",
       "LastActivity": "28/11/2024 08:08:11",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Adrian",
       "Lastname": "Burch",
       "Email": "adrian.burch@corporate.com",
       "LastActivity": "05/11/2024 07:00:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rasheed",
       "Lastname": "Albright",
       "Email": "rasheed.albright@corporate.com",
       "LastActivity": "27/11/2024 07:41:16",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Keanu",
       "Lastname": "Sutton",
       "Email": "keanu.sutton@corporate.com",
       "LastActivity": "03/02/2024 18:29:00",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Keyshawn",
       "Lastname": "Bolin",
       "Email": "keyshawn.bolin@corporate.com",
       "LastActivity": "12/11/2024 06:38:34",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Leighton",
       "Lastname": "Slater",
       "Email": "leighton.slater@corporate.com",
       "LastActivity": "24/11/2024 17:04:34",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Carlton",
       "Lastname": "Dukes",
       "Email": "carlton.dukes@corporate.com",
       "LastActivity": "01/12/2024 19:36:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Emerald",
       "Lastname": "Nieves",
       "Email": "emerald.nieves@corporate.com",
       "LastActivity": "11/12/2024 08:23:55",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jayvon",
       "Lastname": "Seifert",
       "Email": "jayvon.seifert@corporate.com",
       "LastActivity": "10/12/2024 07:37:34",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ladarius",
       "Lastname": "Schaffer",
       "Email": "ladarius.schaffer@corporate.com",
       "LastActivity": "19/11/2024 13:30:30",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Sarahi",
       "Lastname": "McCombs",
       "Email": "sarahi.mccombs@corporate.com",
       "LastActivity": "07/11/2024 05:11:47",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Gaige",
       "Lastname": "Ramon",
       "Email": "gaige.ramon@corporate.com",
       "LastActivity": "07/11/2024 20:21:35",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Arjun",
       "Lastname": "Medeiros",
       "Email": "arjun.medeiros@corporate.com",
       "LastActivity": "02/12/2024 23:07:40",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Amelia",
       "Lastname": "Batista",
       "Email": "amelia.batista@corporate.com",
       "LastActivity": "24/11/2024 13:50:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ivan",
       "Lastname": "Cohn",
       "Email": "ivan.cohn@corporate.com",
       "LastActivity": "09/12/2024 03:56:36",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tatiyana",
       "Lastname": "Conte",
       "Email": "tatiyana.conte@corporate.com",
       "LastActivity": "07/11/2024 09:35:34",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jordin",
       "Lastname": "Hopper",
       "Email": "jordin.hopper@corporate.com",
       "LastActivity": "22/11/2024 17:12:16",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rahul",
       "Lastname": "Dallas",
       "Email": "rahul.dallas@corporate.com",
       "LastActivity": "04/12/2024 05:53:47",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ana",
       "Lastname": "McMahan",
       "Email": "ana.mcmahan@corporate.com",
       "LastActivity": "05/12/2024 19:42:02",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ellie",
       "Lastname": "Rico",
       "Email": "ellie.rico@corporate.com",
       "LastActivity": "21/11/2024 03:55:38",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ellen",
       "Lastname": "Steffen",
       "Email": "ellen.steffen@corporate.com",
       "LastActivity": "01/11/2024 13:43:08",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Myron",
       "Lastname": "Carman",
       "Email": "myron.carman@corporate.com",
       "LastActivity": "04/11/2024 09:11:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cristina",
       "Lastname": "Pritchett",
       "Email": "cristina.pritchett@corporate.com",
       "LastActivity": "09/11/2024 11:37:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jaida",
       "Lastname": "Lawrence",
       "Email": "jaida.lawrence@corporate.com",
       "LastActivity": "25/11/2024 08:26:17",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Franklin",
       "Lastname": "Botello",
       "Email": "franklin.botello@corporate.com",
       "LastActivity": "10/12/2024 16:44:45",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Yvonne",
       "Lastname": "Newell",
       "Email": "yvonne.newell@corporate.com",
       "LastActivity": "24/11/2024 04:30:53",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Bobbie",
       "Lastname": "Ford",
       "Email": "bobbie.ford@corporate.com",
       "LastActivity": "11/12/2024 19:08:09",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Melia",
       "Lastname": "Stephenson",
       "Email": "melia.stephenson@corporate.com",
       "LastActivity": "01/12/2024 22:24:14",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jose",
       "Lastname": "Goode",
       "Email": "jose.goode@corporate.com",
       "LastActivity": "02/12/2024 03:56:37",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Blair",
       "Lastname": "Crews",
       "Email": "blair.crews@corporate.com",
       "LastActivity": "16/03/2024 05:29:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jayden",
       "Lastname": "Velasco",
       "Email": "jayden.velasco@corporate.com",
       "LastActivity": "03/11/2024 12:17:39",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dalia",
       "Lastname": "Morrison",
       "Email": "dalia.morrison@corporate.com",
       "LastActivity": "01/12/2024 13:25:12",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jayson",
       "Lastname": "Brandon",
       "Email": "jayson.brandon@corporate.com",
       "LastActivity": "24/11/2024 19:13:50",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Wendy",
       "Lastname": "Greene",
       "Email": "wendy.greene@corporate.com",
       "LastActivity": "04/12/2024 23:58:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Samuel",
       "Lastname": "Vera",
       "Email": "samuel.vera@corporate.com",
       "LastActivity": "05/12/2024 00:51:45",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Averi",
       "Lastname": "Villareal",
       "Email": "averi.villareal@corporate.com",
       "LastActivity": "03/12/2024 11:30:57",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Will",
       "Lastname": "Hightower",
       "Email": "will.hightower@corporate.com",
       "LastActivity": "02/12/2024 13:06:39",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Conner",
       "Lastname": "Alonzo",
       "Email": "conner.alonzo@corporate.com",
       "LastActivity": "07/12/2024 23:02:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Luke",
       "Lastname": "Parish",
       "Email": "luke.parish@corporate.com",
       "LastActivity": "22/11/2024 05:28:19",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lesli",
       "Lastname": "Abernathy",
       "Email": "lesli.abernathy@corporate.com",
       "LastActivity": "11/12/2024 12:06:57",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Chancellor",
       "Lastname": "Hand",
       "Email": "chancellor.hand@corporate.com",
       "LastActivity": "09/12/2024 20:59:41",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Immanuel",
       "Lastname": "Romo",
       "Email": "immanuel.romo@corporate.com",
       "LastActivity": "05/12/2024 05:39:14",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alexzander",
       "Lastname": "Bayer",
       "Email": "alexzander.bayer@corporate.com",
       "LastActivity": "02/11/2024 04:11:22",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Donte",
       "Lastname": "Heim",
       "Email": "donte.heim@corporate.com",
       "LastActivity": "07/12/2024 06:41:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Korbin",
       "Lastname": "Fields",
       "Email": "korbin.fields@corporate.com",
       "LastActivity": "08/11/2024 03:51:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Conrad",
       "Lastname": "Kramer",
       "Email": "conrad.kramer@corporate.com",
       "LastActivity": "03/12/2024 08:33:35",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Neil",
       "Lastname": "Kee",
       "Email": "neil.kee@corporate.com",
       "LastActivity": "21/11/2024 21:50:59",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Emelia",
       "Lastname": "Conroy",
       "Email": "emelia.conroy@corporate.com",
       "LastActivity": "09/12/2024 09:55:59",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Madison",
       "Lastname": "Faircloth",
       "Email": "madison.faircloth@corporate.com",
       "LastActivity": "10/11/2024 01:34:15",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Aaliyah",
       "Lastname": "Marvin",
       "Email": "aaliyah.marvin@corporate.com",
       "LastActivity": "06/12/2024 17:24:45",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mauro",
       "Lastname": "Stuart",
       "Email": "mauro.stuart@corporate.com",
       "LastActivity": "08/11/2024 07:29:15",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Gene",
       "Lastname": "Horn",
       "Email": "gene.horn@corporate.com",
       "LastActivity": "13/11/2024 06:19:56",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Demi",
       "Lastname": "Gorman",
       "Email": "demi.gorman@corporate.com",
       "LastActivity": "14/11/2024 07:16:52",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Baylie",
       "Lastname": "Estrada",
       "Email": "baylie.estrada@corporate.com",
       "LastActivity": "11/11/2024 16:59:05",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Trevion",
       "Lastname": "Feeney",
       "Email": "trevion.feeney@corporate.com",
       "LastActivity": "27/11/2024 15:13:01",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marcus",
       "Lastname": "Bartholomew",
       "Email": "marcus.bartholomew@corporate.com",
       "LastActivity": "06/12/2024 08:56:19",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Julissa",
       "Lastname": "Warner",
       "Email": "julissa.warner@corporate.com",
       "LastActivity": "18/11/2024 09:07:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Anya",
       "Lastname": "Gipson",
       "Email": "anya.gipson@corporate.com",
       "LastActivity": "03/11/2024 12:14:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marla",
       "Lastname": "Hubbard",
       "Email": "marla.hubbard@corporate.com",
       "LastActivity": "06/11/2024 09:54:08",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tucker",
       "Lastname": "Hoy",
       "Email": "tucker.hoy@corporate.com",
       "LastActivity": "14/11/2024 21:12:52",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Virginia",
       "Lastname": "Carvalho",
       "Email": "virginia.carvalho@corporate.com",
       "LastActivity": "01/11/2024 03:41:17",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Allysa",
       "Lastname": "Briones",
       "Email": "allysa.briones@corporate.com",
       "LastActivity": "04/11/2024 06:09:46",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alexis",
       "Lastname": "Grayson",
       "Email": "alexis.grayson@corporate.com",
       "LastActivity": "02/11/2024 16:57:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Enzo",
       "Lastname": "McCauley",
       "Email": "enzo.mccauley@corporate.com",
       "LastActivity": "18/11/2024 10:47:03",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ali",
       "Lastname": "Santos",
       "Email": "ali.santos@corporate.com",
       "LastActivity": "06/11/2024 07:29:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ismael",
       "Lastname": "Olivas",
       "Email": "ismael.olivas@corporate.com",
       "LastActivity": "04/12/2024 22:07:48",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Janie",
       "Lastname": "Santamaria",
       "Email": "janie.santamaria@corporate.com",
       "LastActivity": "08/11/2024 21:39:15",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Drew",
       "Lastname": "Cao",
       "Email": "drew.cao@corporate.com",
       "LastActivity": "10/12/2024 09:56:13",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Chelsea",
       "Lastname": "Legg",
       "Email": "chelsea.legg@corporate.com",
       "LastActivity": "10/11/2024 02:54:18",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Amani",
       "Lastname": "Gomez",
       "Email": "amani.gomez@corporate.com",
       "LastActivity": "04/11/2024 00:45:21",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Phoebe",
       "Lastname": "Scales",
       "Email": "phoebe.scales@corporate.com",
       "LastActivity": "06/11/2024 13:10:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ruben",
       "Lastname": "Calderon",
       "Email": "ruben.calderon@corporate.com",
       "LastActivity": "11/11/2024 07:43:28",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Janie",
       "Lastname": "Willis",
       "Email": "janie.willis@corporate.com",
       "LastActivity": "05/11/2024 00:47:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jacob",
       "Lastname": "Wright",
       "Email": "jacob.wright@corporate.com",
       "LastActivity": "16/11/2024 06:57:56",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jackie",
       "Lastname": "Morrison",
       "Email": "jackie.morrison@corporate.com",
       "LastActivity": "09/12/2024 22:56:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Juliana",
       "Lastname": "Griffin",
       "Email": "juliana.griffin@corporate.com",
       "LastActivity": "30/11/2024 00:29:53",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Darian",
       "Lastname": "Abreu",
       "Email": "darian.abreu@corporate.com",
       "LastActivity": "24/11/2024 00:12:26",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lilly",
       "Lastname": "Ruggiero",
       "Email": "lilly.ruggiero@corporate.com",
       "LastActivity": "02/12/2024 13:11:49",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Deanna",
       "Lastname": "Stanford",
       "Email": "deanna.stanford@corporate.com",
       "LastActivity": "30/11/2024 12:20:39",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kenyon",
       "Lastname": "Frazier",
       "Email": "kenyon.frazier@corporate.com",
       "LastActivity": "07/11/2024 21:43:45",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dakota",
       "Lastname": "Terry",
       "Email": "dakota.terry@corporate.com",
       "LastActivity": "24/11/2024 15:37:49",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Keara",
       "Lastname": "Hanes",
       "Email": "keara.hanes@corporate.com",
       "LastActivity": "01/12/2024 18:33:09",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Laci",
       "Lastname": "Whitt",
       "Email": "laci.whitt@corporate.com",
       "LastActivity": "15/11/2024 23:25:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jayna",
       "Lastname": "Starling",
       "Email": "jayna.starling@corporate.com",
       "LastActivity": "11/12/2024 01:57:11",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Terrence",
       "Lastname": "Solorzano",
       "Email": "terrence.solorzano@corporate.com",
       "LastActivity": "27/11/2024 11:49:54",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Deon",
       "Lastname": "Wenger",
       "Email": "deon.wenger@corporate.com",
       "LastActivity": "30/11/2024 21:44:58",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Anders",
       "Lastname": "Dill",
       "Email": "anders.dill@corporate.com",
       "LastActivity": "03/11/2024 03:38:03",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dakota",
       "Lastname": "Ray",
       "Email": "dakota.ray@corporate.com",
       "LastActivity": "11/12/2024 11:41:19",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cristal",
       "Lastname": "Peralta",
       "Email": "cristal.peralta@corporate.com",
       "LastActivity": "06/11/2024 00:58:01",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Diego",
       "Lastname": "Britt",
       "Email": "diego.britt@corporate.com",
       "LastActivity": "30/11/2024 19:42:47",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jailyn",
       "Lastname": "Kane",
       "Email": "jailyn.kane@corporate.com",
       "LastActivity": "13/11/2024 18:17:47",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Zaria",
       "Lastname": "Ammons",
       "Email": "zaria.ammons@corporate.com",
       "LastActivity": "03/12/2024 06:09:55",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Andrew",
       "Lastname": "Tejada",
       "Email": "andrew.tejada@corporate.com",
       "LastActivity": "20/11/2024 10:05:07",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Karl",
       "Lastname": "Penny",
       "Email": "karl.penny@corporate.com",
       "LastActivity": "20/11/2024 17:39:22",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ellis",
       "Lastname": "Tarver",
       "Email": "ellis.tarver@corporate.com",
       "LastActivity": "11/12/2024 09:46:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jovanny",
       "Lastname": "Blackwell",
       "Email": "jovanny.blackwell@corporate.com",
       "LastActivity": "04/11/2024 20:42:50",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Akira",
       "Lastname": "Gavin",
       "Email": "akira.gavin@corporate.com",
       "LastActivity": "27/11/2024 17:27:23",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dezmond",
       "Lastname": "Barnes",
       "Email": "dezmond.barnes@corporate.com",
       "LastActivity": "19/11/2024 18:29:08",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kendal",
       "Lastname": "Victor",
       "Email": "kendal.victor@corporate.com",
       "LastActivity": "08/11/2024 21:00:57",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dashaun",
       "Lastname": "Whitworth",
       "Email": "dashaun.whitworth@corporate.com",
       "LastActivity": "01/11/2024 19:39:13",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Xzavier",
       "Lastname": "Coyne",
       "Email": "xzavier.coyne@corporate.com",
       "LastActivity": "04/11/2024 10:02:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tamara",
       "Lastname": "Blakely",
       "Email": "tamara.blakely@corporate.com",
       "LastActivity": "07/12/2024 13:23:09",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lilian",
       "Lastname": "Keenan",
       "Email": "lilian.keenan@corporate.com",
       "LastActivity": "12/11/2024 06:33:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alissa",
       "Lastname": "Martz",
       "Email": "alissa.martz@corporate.com",
       "LastActivity": "23/11/2024 23:31:45",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Grayson",
       "Lastname": "Helm",
       "Email": "grayson.helm@corporate.com",
       "LastActivity": "21/11/2024 08:28:50",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marlene",
       "Lastname": "Pierre",
       "Email": "marlene.pierre@corporate.com",
       "LastActivity": "06/11/2024 01:24:57",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kai",
       "Lastname": "Diaz",
       "Email": "kai.diaz@corporate.com",
       "LastActivity": "09/11/2024 16:30:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Carolyn",
       "Lastname": "Keefe",
       "Email": "carolyn.keefe@corporate.com",
       "LastActivity": "01/12/2024 17:31:57",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Antwan",
       "Lastname": "Dion",
       "Email": "antwan.dion@corporate.com",
       "LastActivity": "26/11/2024 07:51:31",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kendyl",
       "Lastname": "Jewell",
       "Email": "kendyl.jewell@corporate.com",
       "LastActivity": "03/11/2024 23:58:15",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Braxton",
       "Lastname": "Scholl",
       "Email": "braxton.scholl@corporate.com",
       "LastActivity": "10/12/2024 08:50:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Colby",
       "Lastname": "Faulkner",
       "Email": "colby.faulkner@corporate.com",
       "LastActivity": "10/12/2024 13:57:37",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Judith",
       "Lastname": "Storm",
       "Email": "judith.storm@corporate.com",
       "LastActivity": "11/12/2024 04:44:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Donavan",
       "Lastname": "Potter",
       "Email": "donavan.potter@corporate.com",
       "LastActivity": "03/11/2024 13:56:38",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Christy",
       "Lastname": "Tapia",
       "Email": "christy.tapia@corporate.com",
       "LastActivity": "05/12/2024 15:05:24",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kenya",
       "Lastname": "Dell",
       "Email": "kenya.dell@corporate.com",
       "LastActivity": "24/11/2024 23:32:45",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Delilah",
       "Lastname": "Simonson",
       "Email": "delilah.simonson@corporate.com",
       "LastActivity": "06/12/2024 22:37:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Darion",
       "Lastname": "Rowell",
       "Email": "darion.rowell@corporate.com",
       "LastActivity": "07/12/2024 09:26:24",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Bradley",
       "Lastname": "Culp",
       "Email": "bradley.culp@corporate.com",
       "LastActivity": "07/12/2024 23:16:39",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Gissell",
       "Lastname": "Menard",
       "Email": "gissell.menard@corporate.com",
       "LastActivity": "10/12/2024 08:30:49",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Esther",
       "Lastname": "Fleck",
       "Email": "esther.fleck@corporate.com",
       "LastActivity": "01/11/2024 06:24:29",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Douglas",
       "Lastname": "Santos",
       "Email": "douglas.santos@corporate.com",
       "LastActivity": "02/12/2024 15:52:52",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Priscilla",
       "Lastname": "Craig",
       "Email": "priscilla.craig@corporate.com",
       "LastActivity": "29/11/2024 02:52:42",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Chad",
       "Lastname": "Simmons",
       "Email": "chad.simmons@corporate.com",
       "LastActivity": "27/11/2024 16:11:41",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Sabrina",
       "Lastname": "Ball",
       "Email": "sabrina.ball@corporate.com",
       "LastActivity": "20/11/2024 13:53:27",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kamryn",
       "Lastname": "Andrus",
       "Email": "kamryn.andrus@corporate.com",
       "LastActivity": "09/12/2024 06:20:42",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cornelius",
       "Lastname": "Wayne",
       "Email": "cornelius.wayne@corporate.com",
       "LastActivity": "09/11/2024 23:33:58",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jessie",
       "Lastname": "Mackenzie",
       "Email": "jessie.mackenzie@corporate.com",
       "LastActivity": "18/11/2024 02:03:08",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Anne",
       "Lastname": "Dickinson",
       "Email": "anne.dickinson@corporate.com",
       "LastActivity": "02/12/2024 10:58:38",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ruby",
       "Lastname": "Addison",
       "Email": "ruby.addison@corporate.com",
       "LastActivity": "06/12/2024 03:59:10",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Aniya",
       "Lastname": "Worden",
       "Email": "aniya.worden@corporate.com",
       "LastActivity": "24/11/2024 16:53:11",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jorden",
       "Lastname": "Hauser",
       "Email": "jorden.hauser@corporate.com",
       "LastActivity": "01/12/2024 08:57:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Romeo",
       "Lastname": "Caruso",
       "Email": "romeo.caruso@corporate.com",
       "LastActivity": "15/11/2024 22:42:38",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Aman",
       "Lastname": "Covey",
       "Email": "aman.covey@corporate.com",
       "LastActivity": "05/11/2024 04:22:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ervin",
       "Lastname": "Larue",
       "Email": "ervin.larue@corporate.com",
       "LastActivity": "04/11/2024 08:15:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mike",
       "Lastname": "Montague",
       "Email": "mike.montague@corporate.com",
       "LastActivity": "07/11/2024 07:33:49",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Doris",
       "Lastname": "Fernandes",
       "Email": "doris.fernandes@corporate.com",
       "LastActivity": "05/11/2024 06:33:58",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Grant",
       "Lastname": "Major",
       "Email": "grant.major@corporate.com",
       "LastActivity": "30/11/2024 05:37:43",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Valentin",
       "Lastname": "Sadler",
       "Email": "valentin.sadler@corporate.com",
       "LastActivity": "11/11/2024 20:38:59",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Penelope",
       "Lastname": "Trinh",
       "Email": "penelope.trinh@corporate.com",
       "LastActivity": "13/11/2024 04:36:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Manuel",
       "Lastname": "Kiefer",
       "Email": "manuel.kiefer@corporate.com",
       "LastActivity": "03/12/2024 20:19:55",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marlon",
       "Lastname": "Christensen",
       "Email": "marlon.christensen@corporate.com",
       "LastActivity": "25/11/2024 12:05:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Maximilian",
       "Lastname": "Mead",
       "Email": "maximilian.mead@corporate.com",
       "LastActivity": "19/11/2024 09:14:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mya",
       "Lastname": "Wright",
       "Email": "mya.wright@corporate.com",
       "LastActivity": "19/11/2024 00:01:17",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Annalisa",
       "Lastname": "Bohn",
       "Email": "annalisa.bohn@corporate.com",
       "LastActivity": "25/11/2024 14:55:13",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Caley",
       "Lastname": "Harman",
       "Email": "caley.harman@corporate.com",
       "LastActivity": "28/11/2024 03:33:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tatum",
       "Lastname": "Delagarza",
       "Email": "tatum.delagarza@corporate.com",
       "LastActivity": "02/11/2024 00:28:17",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Khadijah",
       "Lastname": "Pfeiffer",
       "Email": "khadijah.pfeiffer@corporate.com",
       "LastActivity": "06/11/2024 03:37:32",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jonah",
       "Lastname": "Viera",
       "Email": "jonah.viera@corporate.com",
       "LastActivity": "03/12/2024 04:27:10",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Santino",
       "Lastname": "Menard",
       "Email": "santino.menard@corporate.com",
       "LastActivity": "28/11/2024 11:41:43",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lamar",
       "Lastname": "Lea",
       "Email": "lamar.lea@corporate.com",
       "LastActivity": "09/12/2024 14:45:19",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Janette",
       "Lastname": "Curry",
       "Email": "janette.curry@corporate.com",
       "LastActivity": "13/11/2024 16:20:31",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Azaria",
       "Lastname": "Tran",
       "Email": "azaria.tran@corporate.com",
       "LastActivity": "11/11/2024 03:58:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Arron",
       "Lastname": "Trout",
       "Email": "arron.trout@corporate.com",
       "LastActivity": "19/11/2024 19:43:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Maeve",
       "Lastname": "Gamboa",
       "Email": "maeve.gamboa@corporate.com",
       "LastActivity": "14/11/2024 06:15:24",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Carmen",
       "Lastname": "Linder",
       "Email": "carmen.linder@corporate.com",
       "LastActivity": "17/11/2024 06:41:12",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Harmony",
       "Lastname": "Gaffney",
       "Email": "harmony.gaffney@corporate.com",
       "LastActivity": "11/11/2024 19:04:51",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Arturo",
       "Lastname": "Batchelor",
       "Email": "arturo.batchelor@corporate.com",
       "LastActivity": "25/11/2024 06:58:04",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ania",
       "Lastname": "Betz",
       "Email": "ania.betz@corporate.com",
       "LastActivity": "01/12/2024 11:02:16",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Elyse",
       "Lastname": "Hannon",
       "Email": "elyse.hannon@corporate.com",
       "LastActivity": "01/11/2024 15:26:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Nicholas",
       "Lastname": "Dugan",
       "Email": "nicholas.dugan@corporate.com",
       "LastActivity": "07/11/2024 17:58:11",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Zakary",
       "Lastname": "Boswell",
       "Email": "zakary.boswell@corporate.com",
       "LastActivity": "10/12/2024 10:17:47",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Katarina",
       "Lastname": "Salinas",
       "Email": "katarina.salinas@corporate.com",
       "LastActivity": "08/12/2024 04:56:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Yosef",
       "Lastname": "Kuhn",
       "Email": "yosef.kuhn@corporate.com",
       "LastActivity": "03/11/2024 23:16:34",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Giana",
       "Lastname": "Brunson",
       "Email": "giana.brunson@corporate.com",
       "LastActivity": "08/11/2024 13:59:09",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Raul",
       "Lastname": "Hartley",
       "Email": "raul.hartley@corporate.com",
       "LastActivity": "21/11/2024 08:14:43",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Louie",
       "Lastname": "Pearce",
       "Email": "louie.pearce@corporate.com",
       "LastActivity": "04/12/2024 10:32:32",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rayven",
       "Lastname": "Lawrence",
       "Email": "rayven.lawrence@corporate.com",
       "LastActivity": "03/12/2024 14:20:18",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Myra",
       "Lastname": "Lumpkin",
       "Email": "myra.lumpkin@corporate.com",
       "LastActivity": "20/11/2024 09:16:42",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Katarina",
       "Lastname": "Richmond",
       "Email": "katarina.richmond@corporate.com",
       "LastActivity": "10/11/2024 15:37:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Reuben",
       "Lastname": "Noll",
       "Email": "reuben.noll@corporate.com",
       "LastActivity": "05/11/2024 14:30:53",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rayna",
       "Lastname": "Emerson",
       "Email": "rayna.emerson@corporate.com",
       "LastActivity": "01/12/2024 02:22:09",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jalin",
       "Lastname": "Millan",
       "Email": "jalin.millan@corporate.com",
       "LastActivity": "01/12/2024 11:44:42",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mira",
       "Lastname": "Arenas",
       "Email": "mira.arenas@corporate.com",
       "LastActivity": "21/11/2024 14:30:45",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lizette",
       "Lastname": "Malcolm",
       "Email": "lizette.malcolm@corporate.com",
       "LastActivity": "06/12/2024 06:45:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cynthia",
       "Lastname": "Mullin",
       "Email": "cynthia.mullin@corporate.com",
       "LastActivity": "04/12/2024 08:28:22",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kendyl",
       "Lastname": "Asbury",
       "Email": "kendyl.asbury@corporate.com",
       "LastActivity": "28/11/2024 07:40:12",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Erika",
       "Lastname": "Snell",
       "Email": "erika.snell@corporate.com",
       "LastActivity": "02/12/2024 01:25:43",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tyrell",
       "Lastname": "Cho",
       "Email": "tyrell.cho@corporate.com",
       "LastActivity": "08/12/2024 02:38:05",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rosalinda",
       "Lastname": "Nagy",
       "Email": "rosalinda.nagy@corporate.com",
       "LastActivity": "10/12/2024 09:12:59",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Joana",
       "Lastname": "Hite",
       "Email": "joana.hite@corporate.com",
       "LastActivity": "23/11/2024 18:22:56",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cruz",
       "Lastname": "Magana",
       "Email": "cruz.magana@corporate.com",
       "LastActivity": "21/11/2024 04:35:02",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Karl",
       "Lastname": "Camacho",
       "Email": "karl.camacho@corporate.com",
       "LastActivity": "02/12/2024 11:37:48",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ben",
       "Lastname": "Plummer",
       "Email": "ben.plummer@corporate.com",
       "LastActivity": "01/11/2024 23:57:18",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marlen",
       "Lastname": "Kellogg",
       "Email": "marlen.kellogg@corporate.com",
       "LastActivity": "11/12/2024 15:17:10",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lola",
       "Lastname": "Gentile",
       "Email": "lola.gentile@corporate.com",
       "LastActivity": "02/11/2024 03:00:05",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Clara",
       "Lastname": "Liles",
       "Email": "clara.liles@corporate.com",
       "LastActivity": "27/11/2024 17:50:14",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marisol",
       "Lastname": "Heaton",
       "Email": "marisol.heaton@corporate.com",
       "LastActivity": "04/12/2024 12:13:22",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jace",
       "Lastname": "Singletary",
       "Email": "jace.singletary@corporate.com",
       "LastActivity": "24/11/2024 01:36:07",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jamir",
       "Lastname": "Sousa",
       "Email": "jamir.sousa@corporate.com",
       "LastActivity": "16/11/2024 21:22:52",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kennedy",
       "Lastname": "Lindstrom",
       "Email": "kennedy.lindstrom@corporate.com",
       "LastActivity": "05/12/2024 19:32:58",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Devyn",
       "Lastname": "Squires",
       "Email": "devyn.squires@corporate.com",
       "LastActivity": "22/11/2024 02:01:51",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kadin",
       "Lastname": "Jaeger",
       "Email": "kadin.jaeger@corporate.com",
       "LastActivity": "08/12/2024 23:09:47",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Edgardo",
       "Lastname": "Mena",
       "Email": "edgardo.mena@corporate.com",
       "LastActivity": "18/11/2024 08:32:40",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jeff",
       "Lastname": "Custer",
       "Email": "jeff.custer@corporate.com",
       "LastActivity": "08/12/2024 13:20:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dan",
       "Lastname": "Gleason",
       "Email": "dan.gleason@corporate.com",
       "LastActivity": "03/11/2024 11:55:04",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Julisa",
       "Lastname": "Schweitzer",
       "Email": "julisa.schweitzer@corporate.com",
       "LastActivity": "16/11/2024 20:36:54",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mordechai",
       "Lastname": "Marin",
       "Email": "mordechai.marin@corporate.com",
       "LastActivity": "10/12/2024 01:18:04",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tierney",
       "Lastname": "Russo",
       "Email": "tierney.russo@corporate.com",
       "LastActivity": "13/11/2024 05:58:14",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Candace",
       "Lastname": "Mundy",
       "Email": "candace.mundy@corporate.com",
       "LastActivity": "02/12/2024 07:35:34",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Nick",
       "Lastname": "Rahman",
       "Email": "nick.rahman@corporate.com",
       "LastActivity": "13/11/2024 17:21:16",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Brionna",
       "Lastname": "Heller",
       "Email": "brionna.heller@corporate.com",
       "LastActivity": "17/11/2024 01:34:52",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Yasmine",
       "Lastname": "Riddle",
       "Email": "yasmine.riddle@corporate.com",
       "LastActivity": "01/11/2024 23:26:41",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Arianna",
       "Lastname": "Hunt",
       "Email": "arianna.hunt@corporate.com",
       "LastActivity": "26/11/2024 20:01:16",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alberto",
       "Lastname": "Boston",
       "Email": "alberto.boston@corporate.com",
       "LastActivity": "01/11/2024 15:33:36",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Marlene",
       "Lastname": "Gallegos",
       "Email": "marlene.gallegos@corporate.com",
       "LastActivity": "11/11/2024 08:40:53",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Notnamed",
       "Lastname": "Bollinger",
       "Email": "notnamed.bollinger@corporate.com",
       "LastActivity": "06/12/2024 20:35:48",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jesse",
       "Lastname": "Turpin",
       "Email": "jesse.turpin@corporate.com",
       "LastActivity": "07/11/2024 05:47:25",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jaden",
       "Lastname": "Crain",
       "Email": "jaden.crain@corporate.com",
       "LastActivity": "11/11/2024 10:39:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Treyvon",
       "Lastname": "Brower",
       "Email": "treyvon.brower@corporate.com",
       "LastActivity": "05/12/2024 06:27:53",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Macey",
       "Lastname": "Huston",
       "Email": "macey.huston@corporate.com",
       "LastActivity": "19/11/2024 08:30:54",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mayra",
       "Lastname": "Carrasco",
       "Email": "mayra.carrasco@corporate.com",
       "LastActivity": "18/11/2024 20:36:07",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jayleen",
       "Lastname": "Dowdy",
       "Email": "jayleen.dowdy@corporate.com",
       "LastActivity": "11/11/2024 12:31:05",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Sydni",
       "Lastname": "Coy",
       "Email": "sydni.coy@corporate.com",
       "LastActivity": "17/11/2024 23:21:25",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ester",
       "Lastname": "Herbert",
       "Email": "ester.herbert@corporate.com",
       "LastActivity": "16/11/2024 03:10:09",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Xzavier",
       "Lastname": "Boucher",
       "Email": "xzavier.boucher@corporate.com",
       "LastActivity": "27/11/2024 10:44:13",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Colette",
       "Lastname": "Ladd",
       "Email": "colette.ladd@corporate.com",
       "LastActivity": "24/11/2024 15:53:10",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jessie",
       "Lastname": "Watters",
       "Email": "jessie.watters@corporate.com",
       "LastActivity": "06/12/2024 04:59:11",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jeffery",
       "Lastname": "Barclay",
       "Email": "jeffery.barclay@corporate.com",
       "LastActivity": "02/11/2024 04:34:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Karlee",
       "Lastname": "Kramer",
       "Email": "karlee.kramer@corporate.com",
       "LastActivity": "01/12/2024 21:19:52",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dennis",
       "Lastname": "Wiggins",
       "Email": "dennis.wiggins@corporate.com",
       "LastActivity": "12/11/2024 12:07:12",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Garrett",
       "Lastname": "Toth",
       "Email": "garrett.toth@corporate.com",
       "LastActivity": "03/11/2024 13:18:37",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Javon",
       "Lastname": "Deluca",
       "Email": "javon.deluca@corporate.com",
       "LastActivity": "19/11/2024 05:50:59",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lucy",
       "Lastname": "Nava",
       "Email": "lucy.nava@corporate.com",
       "LastActivity": "27/11/2024 18:18:37",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kaia",
       "Lastname": "Garza",
       "Email": "kaia.garza@corporate.com",
       "LastActivity": "07/11/2024 20:51:05",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Aylin",
       "Lastname": "Mathis",
       "Email": "aylin.mathis@corporate.com",
       "LastActivity": "04/12/2024 00:04:12",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kale",
       "Lastname": "Brumfield",
       "Email": "kale.brumfield@corporate.com",
       "LastActivity": "10/11/2024 13:28:59",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kameron",
       "Lastname": "Lange",
       "Email": "kameron.lange@corporate.com",
       "LastActivity": "11/12/2024 14:49:39",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ivette",
       "Lastname": "Jacoby",
       "Email": "ivette.jacoby@corporate.com",
       "LastActivity": "08/12/2024 05:44:56",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Quinlan",
       "Lastname": "Frey",
       "Email": "quinlan.frey@corporate.com",
       "LastActivity": "18/11/2024 16:25:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Evelin",
       "Lastname": "Jeter",
       "Email": "evelin.jeter@corporate.com",
       "LastActivity": "23/11/2024 18:11:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Irma",
       "Lastname": "Ames",
       "Email": "irma.ames@corporate.com",
       "LastActivity": "08/12/2024 23:02:37",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kaylea",
       "Lastname": "Trout",
       "Email": "kaylea.trout@corporate.com",
       "LastActivity": "08/12/2024 00:47:04",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Caleb",
       "Lastname": "Devore",
       "Email": "caleb.devore@corporate.com",
       "LastActivity": "19/11/2024 22:33:59",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tionne",
       "Lastname": "Stock",
       "Email": "tionne.stock@corporate.com",
       "LastActivity": "07/12/2024 05:41:58",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Riley",
       "Lastname": "Easton",
       "Email": "riley.easton@corporate.com",
       "LastActivity": "29/11/2024 06:05:56",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kortney",
       "Lastname": "Trapp",
       "Email": "kortney.trapp@corporate.com",
       "LastActivity": "17/11/2024 11:20:06",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kareem",
       "Lastname": "Dill",
       "Email": "kareem.dill@corporate.com",
       "LastActivity": "28/11/2024 03:17:21",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Shamar",
       "Lastname": "Paredes",
       "Email": "shamar.paredes@corporate.com",
       "LastActivity": "29/11/2024 06:43:39",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Laila",
       "Lastname": "Sanderson",
       "Email": "laila.sanderson@corporate.com",
       "LastActivity": "01/12/2024 11:06:53",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Joaquin",
       "Lastname": "Fraley",
       "Email": "joaquin.fraley@corporate.com",
       "LastActivity": "28/11/2024 04:28:04",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Malka",
       "Lastname": "Conte",
       "Email": "malka.conte@corporate.com",
       "LastActivity": "01/12/2024 21:08:14",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Nina",
       "Lastname": "Mattox",
       "Email": "nina.mattox@corporate.com",
       "LastActivity": "09/11/2024 23:39:30",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Janet",
       "Lastname": "Knutson",
       "Email": "janet.knutson@corporate.com",
       "LastActivity": "07/11/2024 22:04:31",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Hadley",
       "Lastname": "Coburn",
       "Email": "hadley.coburn@corporate.com",
       "LastActivity": "18/11/2024 20:44:49",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Donovan",
       "Lastname": "Bullard",
       "Email": "donovan.bullard@corporate.com",
       "LastActivity": "01/11/2024 13:11:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alesha",
       "Lastname": "Hubert",
       "Email": "alesha.hubert@corporate.com",
       "LastActivity": "26/11/2024 13:05:40",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rhett",
       "Lastname": "Coulter",
       "Email": "rhett.coulter@corporate.com",
       "LastActivity": "14/11/2024 13:25:31",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ileana",
       "Lastname": "Grooms",
       "Email": "ileana.grooms@corporate.com",
       "LastActivity": "15/11/2024 13:54:47",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mustafa",
       "Lastname": "Mercer",
       "Email": "mustafa.mercer@corporate.com",
       "LastActivity": "18/11/2024 07:14:05",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Hayleigh",
       "Lastname": "Milligan",
       "Email": "hayleigh.milligan@corporate.com",
       "LastActivity": "13/11/2024 13:43:30",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Antwan",
       "Lastname": "Clapp",
       "Email": "antwan.clapp@corporate.com",
       "LastActivity": "14/11/2024 19:14:11",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dylan",
       "Lastname": "Provost",
       "Email": "dylan.provost@corporate.com",
       "LastActivity": "03/12/2024 14:46:20",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Taylor",
       "Lastname": "Foy",
       "Email": "taylor.foy@corporate.com",
       "LastActivity": "11/11/2024 23:06:00",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Leilani",
       "Lastname": "Huston",
       "Email": "leilani.huston@corporate.com",
       "LastActivity": "07/12/2024 10:49:43",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Luca",
       "Lastname": "Balderas",
       "Email": "luca.balderas@corporate.com",
       "LastActivity": "08/11/2024 14:46:35",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jamir",
       "Lastname": "Heaton",
       "Email": "jamir.heaton@corporate.com",
       "LastActivity": "20/11/2024 21:38:30",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lizette",
       "Lastname": "Figueroa",
       "Email": "lizette.figueroa@corporate.com",
       "LastActivity": "21/11/2024 11:10:31",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mallorie",
       "Lastname": "Carver",
       "Email": "mallorie.carver@corporate.com",
       "LastActivity": "01/12/2024 22:44:58",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Deandre",
       "Lastname": "Brandenburg",
       "Email": "deandre.brandenburg@corporate.com",
       "LastActivity": "13/11/2024 13:20:03",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jakob",
       "Lastname": "Wilburn",
       "Email": "jakob.wilburn@corporate.com",
       "LastActivity": "23/11/2024 09:41:48",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Miya",
       "Lastname": "Cutler",
       "Email": "miya.cutler@corporate.com",
       "LastActivity": "10/12/2024 17:46:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Aubrey",
       "Lastname": "Franz",
       "Email": "aubrey.franz@corporate.com",
       "LastActivity": "08/11/2024 12:41:50",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Analisa",
       "Lastname": "Browne",
       "Email": "analisa.browne@corporate.com",
       "LastActivity": "27/11/2024 19:08:12",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Shea",
       "Lastname": "Christensen",
       "Email": "shea.christensen@corporate.com",
       "LastActivity": "02/12/2024 01:33:30",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Esperanza",
       "Lastname": "Pardo",
       "Email": "esperanza.pardo@corporate.com",
       "LastActivity": "14/11/2024 05:18:17",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jaidyn",
       "Lastname": "Unger",
       "Email": "jaidyn.unger@corporate.com",
       "LastActivity": "05/12/2024 03:12:47",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Rylan",
       "Lastname": "Pantoja",
       "Email": "rylan.pantoja@corporate.com",
       "LastActivity": "07/12/2024 11:12:24",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Weston",
       "Lastname": "Crocker",
       "Email": "weston.crocker@corporate.com",
       "LastActivity": "25/11/2024 03:28:23",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jakob",
       "Lastname": "Mares",
       "Email": "jakob.mares@corporate.com",
       "LastActivity": "09/12/2024 09:01:15",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Kara",
       "Lastname": "Vidal",
       "Email": "kara.vidal@corporate.com",
       "LastActivity": "21/11/2024 08:38:40",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Eddy",
       "Lastname": "Melendez",
       "Email": "eddy.melendez@corporate.com",
       "LastActivity": "08/12/2024 19:00:13",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Josef",
       "Lastname": "Bowling",
       "Email": "josef.bowling@corporate.com",
       "LastActivity": "10/12/2024 01:25:06",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Cydney",
       "Lastname": "Horvath",
       "Email": "cydney.horvath@corporate.com",
       "LastActivity": "27/11/2024 22:15:39",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ashanti",
       "Lastname": "Woo",
       "Email": "ashanti.woo@corporate.com",
       "LastActivity": "08/12/2024 06:58:17",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Konner",
       "Lastname": "Singer",
       "Email": "konner.singer@corporate.com",
       "LastActivity": "10/12/2024 20:41:17",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Toby",
       "Lastname": "Dempsey",
       "Email": "toby.dempsey@corporate.com",
       "LastActivity": "25/11/2024 01:29:14",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Karson",
       "Lastname": "Byers",
       "Email": "karson.byers@corporate.com",
       "LastActivity": "25/11/2024 15:57:45",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jensen",
       "Lastname": "Padron",
       "Email": "jensen.padron@corporate.com",
       "LastActivity": "02/12/2024 10:19:55",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Denise",
       "Lastname": "Dias",
       "Email": "denise.dias@corporate.com",
       "LastActivity": "04/12/2024 00:51:38",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lilliana",
       "Lastname": "Earl",
       "Email": "lilliana.earl@corporate.com",
       "LastActivity": "05/11/2024 08:53:22",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tavian",
       "Lastname": "Sparks",
       "Email": "tavian.sparks@corporate.com",
       "LastActivity": "13/11/2024 00:19:33",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Karyme",
       "Lastname": "Freeland",
       "Email": "karyme.freeland@corporate.com",
       "LastActivity": "13/11/2024 11:35:13",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jaiden",
       "Lastname": "Epstein",
       "Email": "jaiden.epstein@corporate.com",
       "LastActivity": "07/12/2024 06:36:38",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Semaj",
       "Lastname": "Waterman",
       "Email": "semaj.waterman@corporate.com",
       "LastActivity": "28/11/2024 13:54:54",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Martha",
       "Lastname": "Yoon",
       "Email": "martha.yoon@corporate.com",
       "LastActivity": "21/11/2024 18:27:45",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Mika",
       "Lastname": "Seitz",
       "Email": "mika.seitz@corporate.com",
       "LastActivity": "08/11/2024 22:16:06",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jalin",
       "Lastname": "Wiley",
       "Email": "jalin.wiley@corporate.com",
       "LastActivity": "11/12/2024 22:43:32",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Zion",
       "Lastname": "Harper",
       "Email": "zion.harper@corporate.com",
       "LastActivity": "25/11/2024 11:12:22",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alfonso",
       "Lastname": "Pressley",
       "Email": "alfonso.pressley@corporate.com",
       "LastActivity": "03/12/2024 15:52:30",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dario",
       "Lastname": "Salcido",
       "Email": "dario.salcido@corporate.com",
       "LastActivity": "13/11/2024 15:15:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Salvatore",
       "Lastname": "Quiroz",
       "Email": "salvatore.quiroz@corporate.com",
       "LastActivity": "30/11/2024 20:54:03",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Tiana",
       "Lastname": "Hargis",
       "Email": "tiana.hargis@corporate.com",
       "LastActivity": "10/11/2024 12:40:29",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Berenice",
       "Lastname": "Coulter",
       "Email": "berenice.coulter@corporate.com",
       "LastActivity": "02/12/2024 15:36:30",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Dillan",
       "Lastname": "Ferguson",
       "Email": "dillan.ferguson@corporate.com",
       "LastActivity": "01/11/2024 23:32:08",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Remington",
       "Lastname": "Hoffman",
       "Email": "remington.hoffman@corporate.com",
       "LastActivity": "01/11/2024 15:47:40",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jazlyn",
       "Lastname": "Slack",
       "Email": "jazlyn.slack@corporate.com",
       "LastActivity": "01/11/2024 20:25:08",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Ciera",
       "Lastname": "Fritz",
       "Email": "ciera.fritz@corporate.com",
       "LastActivity": "25/11/2024 02:55:07",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Trever",
       "Lastname": "Trahan",
       "Email": "trever.trahan@corporate.com",
       "LastActivity": "02/12/2024 04:20:33",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Pierce",
       "Lastname": "Birch",
       "Email": "pierce.birch@corporate.com",
       "LastActivity": "19/11/2024 14:46:16",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Estrella",
       "Lastname": "Burger",
       "Email": "estrella.burger@corporate.com",
       "LastActivity": "25/11/2024 03:58:20",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Gunnar",
       "Lastname": "Hair",
       "Email": "gunnar.hair@corporate.com",
       "LastActivity": "28/11/2024 09:18:15",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Paxton",
       "Lastname": "Frey",
       "Email": "paxton.frey@corporate.com",
       "LastActivity": "07/11/2024 20:06:27",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Alfonso",
       "Lastname": "Schumacher",
       "Email": "alfonso.schumacher@corporate.com",
       "LastActivity": "06/11/2024 18:10:44",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Lynsey",
       "Lastname": "Hopkins",
       "Email": "lynsey.hopkins@corporate.com",
       "LastActivity": "25/11/2024 04:14:14",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Jerry",
       "Lastname": "Roach",
       "Email": "jerry.roach@corporate.com",
       "LastActivity": "10/11/2024 03:44:16",
       "MFAStatus": "FALSE",
       "PrivilegedRoles": "-"
     },
     {
       "Source": "EntraID",
       "Firstname": "Albert",
       "Lastname": "Cullen",
       "Email": "albert.cullen@corporate.com",
       "LastActivity": "06/12/2024 21:28:18",
       "MFAStatus": "TRUE",
       "PrivilegedRoles": "-"
     }
];

export const assetsRows: assetsSampleDataRow[] = [
  {
    "Source": "EntraID",
    "ID": "1",
    "Hostname": "LON10001",
    "IPAddress": "192.168.0.1",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "09/12/2024 23:33:14",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "2",
    "Hostname": "LON10002",
    "IPAddress": "192.168.0.2",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "19/11/2024 20:37:08",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "3",
    "Hostname": "LON10003",
    "IPAddress": "192.168.0.3",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "07/12/2024 23:45:16",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "4",
    "Hostname": "LON10004",
    "IPAddress": "192.168.0.4",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "13/12/2024 02:22:35",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "5",
    "Hostname": "LON10005",
    "IPAddress": "192.168.0.5",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "25/11/2024 13:06:39",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "6",
    "Hostname": "LON10006",
    "IPAddress": "192.168.0.6",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "10/12/2024 18:13:56",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "7",
    "Hostname": "LON10007",
    "IPAddress": "192.168.0.7",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "15/11/2024 16:55:07",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "8",
    "Hostname": "LON10008",
    "IPAddress": "192.168.0.8",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "02/12/2024 17:28:42",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "9",
    "Hostname": "LON10009",
    "IPAddress": "192.168.0.9",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "26/11/2024 10:02:54",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "10",
    "Hostname": "LON10010",
    "IPAddress": "192.168.0.10",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "11/12/2024 08:58:29",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "11",
    "Hostname": "LON10011",
    "IPAddress": "192.168.0.11",
    "OSType": "Linux",
    "OSName": "Linux",
    "OSVersion": "16",
    "LastSeen": "23/11/2024 16:45:17",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "12",
    "Hostname": "LON10012",
    "IPAddress": "192.168.0.12",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "13/12/2024 15:01:11",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "13",
    "Hostname": "LON10013",
    "IPAddress": "192.168.0.13",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "18/11/2024 03:52:42",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "14",
    "Hostname": "LON10014",
    "IPAddress": "192.168.0.14",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "11/12/2024 23:45:13",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "15",
    "Hostname": "LON10015",
    "IPAddress": "192.168.0.15",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "15/11/2024 23:43:11",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "16",
    "Hostname": "LON10016",
    "IPAddress": "192.168.0.16",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "02/12/2024 10:42:33",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "17",
    "Hostname": "LON10017",
    "IPAddress": "192.168.0.17",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "08/12/2024 21:42:24",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "18",
    "Hostname": "LON10018",
    "IPAddress": "192.168.0.18",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "01/12/2024 10:19:11",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "FALSE"
  },
  {
    "Source": "EntraID",
    "ID": "19",
    "Hostname": "LON10019",
    "IPAddress": "192.168.0.19",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "15/11/2024 23:33:15",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "20",
    "Hostname": "LON10020",
    "IPAddress": "192.168.0.20",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "17/11/2024 09:10:10",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "21",
    "Hostname": "LON10021",
    "IPAddress": "192.168.0.21",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "25/11/2024 16:57:39",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "FALSE"
  },
  {
    "Source": "EntraID",
    "ID": "22",
    "Hostname": "LON10022",
    "IPAddress": "192.168.0.22",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "25/11/2024 16:28:01",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "23",
    "Hostname": "LON10023",
    "IPAddress": "192.168.0.23",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "29/11/2024 23:57:53",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "24",
    "Hostname": "LON10024",
    "IPAddress": "192.168.0.24",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "30/11/2024 03:42:04",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "25",
    "Hostname": "LON10025",
    "IPAddress": "192.168.0.25",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "20/11/2024 13:55:24",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "26",
    "Hostname": "LON10026",
    "IPAddress": "192.168.0.26",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "01/12/2024 14:37:48",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "27",
    "Hostname": "LON10027",
    "IPAddress": "192.168.0.27",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "28/11/2024 09:39:40",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "28",
    "Hostname": "LON10028",
    "IPAddress": "192.168.0.28",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "27/11/2024 12:44:10",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "29",
    "Hostname": "LON10029",
    "IPAddress": "192.168.0.29",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "21/11/2024 14:40:20",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "30",
    "Hostname": "LON10030",
    "IPAddress": "192.168.0.30",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "13/12/2024 03:58:08",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "31",
    "Hostname": "LON10031",
    "IPAddress": "192.168.0.31",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "05/12/2024 21:20:43",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "32",
    "Hostname": "LON10032",
    "IPAddress": "192.168.0.32",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "25/11/2024 00:04:45",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "33",
    "Hostname": "LON10033",
    "IPAddress": "192.168.0.33",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "15/03/2024 21:01:01",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "34",
    "Hostname": "LON10034",
    "IPAddress": "192.168.0.34",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "06/12/2024 00:02:24",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "35",
    "Hostname": "LON10035",
    "IPAddress": "192.168.0.35",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "24/11/2024 18:14:41",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "36",
    "Hostname": "LON10036",
    "IPAddress": "192.168.0.36",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "12/12/2024 12:01:44",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "37",
    "Hostname": "LON10037",
    "IPAddress": "192.168.0.37",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "15/11/2024 02:01:39",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "38",
    "Hostname": "LON10038",
    "IPAddress": "192.168.0.38",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "14/11/2024 08:08:27",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "39",
    "Hostname": "LON10039",
    "IPAddress": "192.168.0.39",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "30/11/2024 05:47:04",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "40",
    "Hostname": "LON10040",
    "IPAddress": "192.168.0.40",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "26/11/2024 06:28:25",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "41",
    "Hostname": "LON10041",
    "IPAddress": "192.168.0.41",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "20/11/2024 03:44:48",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "42",
    "Hostname": "LON10042",
    "IPAddress": "192.168.0.42",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "20/11/2024 10:25:51",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "43",
    "Hostname": "LON10043",
    "IPAddress": "192.168.0.43",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "19/11/2024 03:59:21",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "44",
    "Hostname": "LON10044",
    "IPAddress": "192.168.0.44",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "21/11/2024 07:03:20",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "45",
    "Hostname": "LON10045",
    "IPAddress": "192.168.0.45",
    "OSType": "Linux",
    "OSName": "",
    "OSVersion": "16",
    "LastSeen": "01/12/2024 03:40:56",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "46",
    "Hostname": "LON10046",
    "IPAddress": "192.168.0.46",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "04/12/2024 02:54:41",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "47",
    "Hostname": "LON10047",
    "IPAddress": "192.168.0.47",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "18/11/2024 14:12:46",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "48",
    "Hostname": "LON10048",
    "IPAddress": "192.168.0.48",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "06/12/2024 21:29:40",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "49",
    "Hostname": "LON10049",
    "IPAddress": "192.168.0.49",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "23/11/2024 06:40:19",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "50",
    "Hostname": "LON10050",
    "IPAddress": "192.168.0.50",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "04/12/2024 04:22:03",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "51",
    "Hostname": "LON10051",
    "IPAddress": "192.168.0.51",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "08/12/2024 03:47:15",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "52",
    "Hostname": "LON10052",
    "IPAddress": "192.168.0.52",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "21/11/2024 09:10:08",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "53",
    "Hostname": "LON10053",
    "IPAddress": "192.168.0.53",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "10/12/2024 20:42:50",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "54",
    "Hostname": "LON10054",
    "IPAddress": "192.168.0.54",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "05/12/2024 13:21:43",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "55",
    "Hostname": "LON10055",
    "IPAddress": "192.168.0.55",
    "OSType": "Linux",
    "OSName": "Linux",
    "OSVersion": "16",
    "LastSeen": "17/02/2024 06:11:04",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "56",
    "Hostname": "LON10056",
    "IPAddress": "192.168.0.56",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "11/12/2024 21:02:48",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "57",
    "Hostname": "LON10057",
    "IPAddress": "192.168.0.57",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "30/11/2024 13:21:26",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "58",
    "Hostname": "LON10058",
    "IPAddress": "192.168.0.58",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "21/11/2024 15:22:26",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "59",
    "Hostname": "LON10059",
    "IPAddress": "192.168.0.59",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "06/12/2024 08:16:58",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "60",
    "Hostname": "LON10060",
    "IPAddress": "192.168.0.60",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "07/12/2024 17:03:19",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "61",
    "Hostname": "LON10061",
    "IPAddress": "192.168.0.61",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "06/12/2024 03:14:51",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "62",
    "Hostname": "LON10062",
    "IPAddress": "192.168.0.62",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "07/12/2024 04:10:40",
    "DefenderCoverage": "FALSE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "63",
    "Hostname": "LON10063",
    "IPAddress": "192.168.0.63",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "02/12/2024 22:20:22",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "64",
    "Hostname": "LON10064",
    "IPAddress": "192.168.0.64",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "12/12/2024 23:59:34",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "65",
    "Hostname": "LON10065",
    "IPAddress": "192.168.0.65",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "02/12/2024 15:25:06",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "66",
    "Hostname": "LON10066",
    "IPAddress": "192.168.0.66",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "19/11/2024 11:33:24",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "67",
    "Hostname": "LON10067",
    "IPAddress": "192.168.0.67",
    "OSType": "Linux",
    "OSName": "Linux",
    "OSVersion": "16",
    "LastSeen": "04/12/2024 02:15:07",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "68",
    "Hostname": "LON10068",
    "IPAddress": "192.168.0.68",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "21/11/2024 07:04:00",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "69",
    "Hostname": "LON10069",
    "IPAddress": "192.168.0.69",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "06/12/2024 18:55:32",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "70",
    "Hostname": "LON10070",
    "IPAddress": "192.168.0.70",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "06/12/2024 01:26:27",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "71",
    "Hostname": "LON10071",
    "IPAddress": "192.168.0.71",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "12/12/2024 13:42:37",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "72",
    "Hostname": "LON10072",
    "IPAddress": "192.168.0.72",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "27/11/2024 10:09:25",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "73",
    "Hostname": "LON10073",
    "IPAddress": "192.168.0.73",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "17/11/2024 19:24:54",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "74",
    "Hostname": "LON10074",
    "IPAddress": "192.168.0.74",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "04/12/2024 18:34:12",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "75",
    "Hostname": "LON10075",
    "IPAddress": "192.168.0.75",
    "OSType": "Linux",
    "OSName": "Linux",
    "OSVersion": "16",
    "LastSeen": "05/12/2024 17:49:54",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "76",
    "Hostname": "LON10076",
    "IPAddress": "192.168.0.76",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "26/11/2024 21:53:54",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "77",
    "Hostname": "LON10077",
    "IPAddress": "192.168.0.77",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "04/12/2024 05:13:15",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "78",
    "Hostname": "LON10078",
    "IPAddress": "192.168.0.78",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "16/11/2024 03:46:04",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "79",
    "Hostname": "LON10079",
    "IPAddress": "192.168.0.79",
    "OSType": "Windows",
    "OSName": "Windows 11",
    "OSVersion": "26100.2605",
    "LastSeen": "09/12/2024 01:52:08",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "80",
    "Hostname": "SVR10080",
    "IPAddress": "192.168.0.80",
    "OSType": "Windows",
    "OSName": "Windows 2012R2",
    "OSVersion": "9600",
    "LastSeen": "22/11/2024 14:40:23",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "81",
    "Hostname": "SVR10081",
    "IPAddress": "192.168.0.81",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "20/11/2024 03:35:06",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "82",
    "Hostname": "SVR10082",
    "IPAddress": "192.168.0.82",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "25/11/2024 13:55:32",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "83",
    "Hostname": "SVR10083",
    "IPAddress": "192.168.0.83",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "01/12/2024 20:35:25",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "84",
    "Hostname": "SVR10084",
    "IPAddress": "192.168.0.84",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "08/12/2024 09:36:33",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "85",
    "Hostname": "SVR10085",
    "IPAddress": "192.168.0.85",
    "OSType": "Linux",
    "OSName": "Linux",
    "OSVersion": "16",
    "LastSeen": "12/12/2024 05:35:37",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "86",
    "Hostname": "SVR10086",
    "IPAddress": "192.168.0.86",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "27/11/2024 06:47:24",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "87",
    "Hostname": "SVR10087",
    "IPAddress": "192.168.0.87",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "06/12/2024 05:55:17",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "88",
    "Hostname": "SVR10088",
    "IPAddress": "192.168.0.88",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "18/11/2024 02:40:39",
    "DefenderCoverage": "FALSE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "89",
    "Hostname": "SVR10089",
    "IPAddress": "192.168.0.89",
    "OSType": "Windows",
    "OSName": "Windows 2019",
    "OSVersion": "17763.6659",
    "LastSeen": "03/12/2024 04:25:25",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "90",
    "Hostname": "SVR10090",
    "IPAddress": "192.168.0.90",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "04/12/2024 12:38:40",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "91",
    "Hostname": "SVR10091",
    "IPAddress": "192.168.0.91",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "14/01/2024 00:26:36",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "92",
    "Hostname": "SVR10092",
    "IPAddress": "192.168.0.92",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "04/12/2024 00:59:02",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "93",
    "Hostname": "SVR10093",
    "IPAddress": "192.168.0.93",
    "OSType": "Linux",
    "OSName": "Linux",
    "OSVersion": "16",
    "LastSeen": "12/12/2024 13:29:32",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "94",
    "Hostname": "SVR10094",
    "IPAddress": "192.168.0.94",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "23/11/2024 08:58:51",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "95",
    "Hostname": "SVR10095",
    "IPAddress": "192.168.0.95",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "20/11/2024 12:20:38",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "96",
    "Hostname": "SVR10096",
    "IPAddress": "192.168.0.96",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "03/12/2024 16:20:40",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "97",
    "Hostname": "SVR10097",
    "IPAddress": "192.168.0.97",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "14/11/2024 09:06:22",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "98",
    "Hostname": "SVR10098",
    "IPAddress": "192.168.0.98",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "25/11/2024 20:15:20",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "99",
    "Hostname": "SVR10099",
    "IPAddress": "192.168.0.99",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "04/12/2024 15:24:38",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  },
  {
    "Source": "EntraID",
    "ID": "100",
    "Hostname": "SVR10100",
    "IPAddress": "192.168.0.100",
    "OSType": "Windows",
    "OSName": "Windows 2022",
    "OSVersion": "20348.2966",
    "LastSeen": "27/11/2024 13:14:37",
    "DefenderCoverage": "TRUE",
    "IntuneCoverage": "TRUE"
  }
];